<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-9">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <div class="loader" v-if="waiting"></div>

                        <form v-if="template">
                            <div class="row">

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="template.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-if="c.id !== 999" v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="template.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Опубликовано</option>
                                            <option value="0">Ожидает</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Тип шаблона</label>
                                        <select v-model="template.type"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="0">Обычный</option>
                                            <option value="1">Slide 2 кусочка (справа-налево)</option>
                                            <option value="2">Slide 3 кусочка (справа-налево)</option>
                                            <option value="3">Slide 2 кусочка (снизу-вверх)</option>
                                            <option value="4">Slide 3 кусочка (снизу-вверх)</option>
                                            <option value="5">Slide слева вниз, справа вверх</option>
                                            <option value="6">Разъезжается центральный кадр</option>
                                            <option value="7">Slide 2 кусочка (слева-направо)</option>
                                            <option value="8">Slide 3 кусочка (слева-направо)</option>
                                            <option value="9">Slide 2 кусочка (сверху-вниз)</option>
                                            <option value="10">Slide 3 кусочка (сверху-вниз)</option>
                                            <option value="11">Разъезжается первый кадр</option>
                                            <option value="12">Появляются по очереди 3 кусочка и уезжают вверх</option>
                                            <option value="13">Cutout (смешанный)</option>
                                            <option value="14">Slide 1 кусочек (справа-налево)</option>
                                            <option value="15">Slide 1 кусочек (слева-направо)</option>
                                            <option value="16">Slide 1 кусочек (снизу-вверх)</option>
                                            <option value="17">Slide 1 кусочек (сверху-вниз)</option>
                                            <option value="18">Съезжается первый кадр</option>
                                            <option value="19">19</option>
                                            <option value="20">20</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Формат</label>
                                        <select v-model="template.ratio"
                                                id="ratio-control"
                                                @change="changeRatioType()"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Обычный</option>
                                            <option value="2">Горизонтальный (16:9)</option>
                                            <option value="3">Горизонтальный (5:1)</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Минимальная версия</label>
                                        <select v-model="template.v" class="form-control">
                                            <option value="">Все версии</option>
                                            <option
                                                v-for="version in versions"
                                                :key="version"
                                                :value="version"
                                            >
                                                {{ version }}
                                            </option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="template.sort"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Название трека"
                                              v-model="template.song"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text" v-if="template.is_copyrighted"
                                              label="Ссылка на Reels audio"
                                              v-model="template.song_insta"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text" v-if="template.is_copyrighted"
                                              label="Ссылка на TikTok audio"
                                              v-model="template.song_tiktok"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="date"
                                              label="Дата публикации (формат ДД.ММ.ГГГГ)"
                                              v-model="template.release_date"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="time" v-if="template.release_date"
                                              label="Время публикации (формат HH:MM)"
                                              v-model="template.release_time"
                                              placeholder="">
                                    </fg-input>

                                    <div>
                                        <h5 slot="header" class="card-title">
                                            Теги:
                                        </h5>

                                        <div class="form-group">
                                            <span class="d-none">{{ template.tags }}</span>
                                            <div class="tags-set">
                                                <div v-for="t in tags"
                                                     :class="{ 'active' : t.active }"
                                                     @click="toggleTag(t)">{{ t.name }}</div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-md-5 checkbox-block">
                                            <div class="form-group">
                                                <label for="premium-control"
                                                       class="control-label label-checkbox">Премиум</label>
                                                <input v-model="template.is_premium" id="premium-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="trendy-control"
                                                       class="control-label label-checkbox">Популярное</label>
                                                <input v-model="template.is_trendy" id="trendy-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="new-control"
                                                       class="control-label label-checkbox">Новое</label>
                                                <input v-model="template.is_new" id="new-control"
                                                       class="form-check-inline"
                                                       type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="trending-music-control"
                                                       class="control-label label-checkbox">Трендовая
                                                    музыка</label>
                                                <input v-model="template.is_trending_music" id="trending-music-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="collage-control"
                                                       class="control-label label-checkbox">Коллаж</label>
                                                <input v-model="template.is_collage" id="collage-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="copyrighted-control" class="control-label label-checkbox">Copyrighted-музыка</label>
                                                <input v-model="template.is_copyrighted" id="copyrighted-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="stories-control" class="control-label label-checkbox">Stories</label>
                                                <input v-model="template.is_stories" id="stories-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="cut-out-control"
                                                       class="control-label label-checkbox">Cutout</label>
                                                <input v-model="template.is_cut_out" id="cut-out-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group" v-if="template.is_cut_out">
                                                <label for="cut-out-control"
                                                       class="control-label label-checkbox">Paper Cutout</label>
                                                <input v-model="template.is_paper_cut_out" id="cut-out-control"
                                                       class="form-check-inline" type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label for="text-control" class="control-label label-checkbox">Наложение
                                                    текста/объекта</label>
                                                <input v-model="is_text_active" @change="toggleText()" id="text-control"
                                                       class="form-check-inline"
                                                       type="checkbox">
                                            </div>
                                            <div class="form-group">
                                                <label class="control-label">Цвет фона: <span class="param-span">{{
                                                        template.background
                                                    }}</span></label>
                                                <input type="color" v-model="template.background">
                                            </div>
                                            <div class="form-group">
                                                <label class="control-label">Эффект</label>
                                                <select v-model="effect"
                                                        id="category-control"
                                                        aria-describedby="addon-right addon-left"
                                                        class="form-control">
                                                    <option value="" selected>-</option>
                                                    <option v-for="se in server_effects" v-bind:value="se.name">
                                                        {{ se.name }}
                                                    </option>
                                                </select>
                                            </div>
                                            <label v-if="effect" class="control-label">Интенсивность эффекта: <span
                                                class="param-span">{{ effect_intensity }}</span></label>
                                            <fg-input type="range" v-if="effect"
                                                      min="0" max="100" step="1"
                                                      label=""
                                                      v-model="effect_intensity"
                                                      placeholder="">
                                            </fg-input>
                                            <div class="form-group">
                                                <label class="control-label">Фильтр</label>
                                                <select v-model="filter"
                                                        id="category-control"
                                                        aria-describedby="addon-right addon-left"
                                                        class="form-control">
                                                    <option value="" selected>-</option>
                                                    <option v-for="sf in server_filters" v-bind:value="sf.name">
                                                        {{ sf.name }}
                                                    </option>
                                                </select>
                                            </div>
                                            <label v-if="filter" class="control-label">Интенсивность фильтра: <span
                                                class="param-span">{{ filter_intensity }}</span></label>
                                            <fg-input type="range" v-if="filter"
                                                      min="0" max="100" step="1"
                                                      label=""
                                                      v-model="filter_intensity"
                                                      placeholder="">
                                            </fg-input>
                                        </div>


                                        <div class="col-md-6">
                                            <div>
                                                <h5 slot="header" class="card-title">
                                                    Видео: <span v-if="template.src">
                                            <span class="inline-link">
                                                <span v-if="template.src_size >= 4"
                                                      class="bg-danger">{{ template.src_size }}Mb</span>
                                                <span v-else-if="template.src_size >= 3"
                                                      class="bg-warning">{{ template.src_size }}Mb</span>
                                                <span v-else>{{ template.src_size }}Mb</span>
                                                <a :href="template.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                                </h5>

                                                <div>
                                                    <input ref="videoFileInput" class="btn-file" type="file"
                                                           @change="uploadFile($event, 'src')">
                                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                                            @click="$refs.videoFileInput.click()">
                                                        Загрузить
                                                    </button>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                            <div class="margin-top">
                                                <h5 slot="header" class="card-title">
                                                    Превью: <span v-if="template.preview_src">
                                            <span class="inline-link">
                                                <span v-if="template.preview_src_size >= 1"
                                                      class="bg-danger">{{ template.preview_src_size }}Mb</span>
                                                <span v-else-if="template.preview_src_size >= 0.5"
                                                      class="bg-warning">{{ template.preview_src_size }}Mb</span>
                                                <span v-else>{{ template.preview_src_size }}Mb</span>
                                                <a :href="template.preview_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                                </h5>

                                                <div>
                                                    <input ref="previewFileInput" class="btn-file" type="file"
                                                           @change="uploadFile($event, 'preview_src')">
                                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                                            @click="$refs.previewFileInput.click()">
                                                        Загрузить
                                                    </button>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                            <div class="margin-top">
                                                <h5 slot="header" class="card-title">
                                                    Аудио: <span v-if="template.audio">
                                            <span class="inline-link">
                                                <span v-if="template.audio_size >= 1"
                                                      class="bg-danger">{{ template.audio_size }}Mb</span>
                                                <span v-else-if="template.audio_size >= 0.5"
                                                      class="bg-warning">{{ template.audio_size }}Mb</span>
                                                <span v-else>{{ template.audio_size }}Mb</span>
                                                <a :href="template.audio_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                                </h5>

                                                <div>
                                                    <input ref="audioFileInput" class="btn-file" type="file"
                                                           accept="audio/mp3"
                                                           @change="uploadFile($event, 'audio')">
                                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                                            @click="$refs.audioFileInput.click()">
                                                        Загрузить
                                                    </button>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                            <div class="margin-top">
                                                <h5 slot="header" class="card-title">
                                                    Обложка (Reels Maker): <span v-if="template.preview_image">
                                            <span class="inline-link">
                                                <span v-if="template.preview_image_size >= 0.1"
                                                      class="bg-danger">{{ template.preview_image_size }}Mb</span>
                                                <span v-else-if="template.preview_image_size >= 0.05"
                                                      class="bg-warning">{{ template.preview_image_size }}Mb</span>
                                                <span v-else>{{ template.preview_image_size }}Mb</span>
                                                <a :href="template.preview_image_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                                </h5>

                                                <div>
                                                    <input ref="previewImageFileInput" class="btn-file" type="file"
                                                           @change="uploadFile($event, 'preview_image')">
                                                    <button type="button" class="btn btn-info btn-fill upload-button"
                                                            @click="$refs.previewImageFileInput.click()">
                                                        Загрузить
                                                    </button>
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="tags">

                                    </div>
                                </div>
                            </div>

                            <!--                            <div class="text-center">-->
                            <!--                                <div class="btn btn-danger btn-fill float-left btn-save"-->
                            <!--                                     @dblclick="remove()">-->
                            <!--                                    Удалить-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!template.duration || !template.videos || !template.category_id || !template.song
                                        || !template.src || !template.preview_src || !template.audio || !template.preview_image
                                        || (template.is_copyrighted == true && (!template.song_insta && !template.song_tiktok))"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                                <button type="submit" class="btn btn-danger btn-fill float-right btn-delete"
                                        @click.prevent="remove">
                                    Удалить шаблон
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>

                    <!--"888"-->
                    <div class="modal-mask" v-if="show_collage_modal" @click="closeCollageModal">
                        <div class="modal-wrapper">
                            <div class="modal-container">

                                <div class="modal-header">
                                    <slot name="header">
                                        <button type="button" class="btn btn-text btn-fill collage-category"
                                                :class="{ 'active' : active_collage_category === 'Custom'}"
                                                @click="selectCollageCategory('Custom')">
                                            Custom
                                        </button>
                                        <button v-for="(t, index) in collages"
                                                type="button" class="btn btn-text btn-fill collage-category"
                                                :class="{ 'active' : t.name === active_collage_category}"
                                                @click="selectCollageCategory(t.name)">
                                            {{ t.name }}
                                        </button>
                                    </slot>
                                </div>

                                <div class="modal-body">
                                    <slot ref="collage" name="body">
                                        <div v-if="active_collage_category === 'Custom'" class="collage-custom-form" @click.stop>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <fg-input type="text"
                                                              label="Ширина фрейма в Figma"
                                                              v-model="custom_collage_rawData.original_w"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Высота фрейма в Figma"
                                                              v-model="custom_collage_rawData.original_h"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Ширина редактируемой области"
                                                              v-model="custom_collage_rawData.w"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Высота редактируемой области"
                                                              v-model="custom_collage_rawData.h"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Отступ сверху"
                                                              v-model="custom_collage_rawData.y"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Отступ слева"
                                                              v-model="custom_collage_rawData.x"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-6">
                                                    <fg-input type="text"
                                                              label="Радиус верхний левый"
                                                              v-model="custom_collage_rawData.b_tl"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Радиус верхний правый"
                                                              v-model="custom_collage_rawData.b_tr"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Радиус нижний правый"
                                                              v-model="custom_collage_rawData.b_br"
                                                              placeholder="">
                                                    </fg-input>
                                                    <fg-input type="text"
                                                              label="Радиус нижний левый"
                                                              v-model="custom_collage_rawData.b_bl"
                                                              placeholder="">
                                                    </fg-input>
                                                    <button type="button" class="btn btn-info btn-fill"
                                                            @click="addCustomCollage">
                                                        Применить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-for="(t, index) in collages">
                                                <div v-for="(c, index) in t.data"
                                                     v-if="t.name === active_collage_category"
                                                     class="collage-item" >
                                                    <div @click="addCollage" v-html="renderCollage(c)"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </slot>
                                </div>

                                <div class="modal-footer collage-modal-footer">
                                    <slot name="footer">
                                        <div class="collage-frame-footer">{{ collageModalFrameText }}</div>
                                        <button class="btn btn-info btn-fill modal-close-button"
                                                @click="closeCollageModal">
                                            Закрыть
                                        </button>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>

                    <card v-show="is_text_active">

                        <h4 slot="header" class="card-title">
                            Текст</h4>

                        <div class="texts-buttons" v-if="is_text_active">
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addText()">Добавить текст
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addText(false, true)">Добавить tool
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="showSVGModal()">Добавить объект
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="showFramesModal()">Добавить фрейм
                            </button>
                        </div>

                        <div class="texts-buttons layers-sticky" ref="layersBar" v-if="is_text_active">
                            <button v-for="(t, index) in template.texts"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_text && active_type === 'text'}"
                                    @click="selectText(index)">{{ t.text }}
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button v-for="(t, index) in template.objects"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_object && active_type === 'object'}"
                                    @click="selectObject(index)">
                                <div class="button-preview"
                                     :style="{ backgroundImage: 'url(\'' + objectPlayerSrc(t) + '\')' }">
                                </div>
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button v-for="(t, index) in template.frames"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_frame && active_type === 'frame'}"
                                    @click="selectFrame(index)">
                                <div class="button-preview"
                                     :style="{ backgroundImage: 'url(' + framesUrl + t.src + ')' }">
                                </div>
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    v-if="(active_type === 'text' && template.texts.length) || (active_type === 'object' && template.objects.length) || (active_type === 'frame' && (template.frames || []).length)"
                                    @click="active_type === 'text' ? addText(active_text) : active_type === 'frame' ? addFrame(null, active_frame) : addObject(null, active_object)">
                                Копировать
                            </button>
                        </div>

                        <div class="modal-mask" v-if="show_svg_modal" @click="closeSVGModal">
                            <div class="modal-wrapper">
                                <div class="modal-container">

                                    <div class="modal-header">
                                        <slot name="header">
                                            <button v-for="(t, index) in server_graphics"
                                                    type="button" class="btn btn-text btn-fill"
                                                    :class="{ 'active' : t.name === active_object_category}"
                                                    @click="selectObjectCategory(t.name)">
                                                {{ t.name }}
                                            </button>
                                        </slot>
                                    </div>

                                    <div class="modal-body">
                                        <slot name="body">
                                            <div v-for="(t, index) in server_graphics">
                                                <div v-for="(c, index) in t.data"
                                                     v-if="t.name === active_object_category"
                                                     class="object-item"
                                                     @click="addObject(c)">
                                                    <img :src="`${graphicsUrl}${c.src}`" class="image">
                                                </div>
                                            </div>
                                        </slot>
                                    </div>

                                    <div class="modal-footer">
                                        <slot name="footer">
                                            <button class="btn btn-info btn-fill modal-close-button"
                                                    @click="closeSVGModal">
                                                Закрыть
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="modal-mask" v-if="show_frames_modal" @click="closeFramesModal">
                            <div class="modal-wrapper">
                                <div class="modal-container">

                                    <div class="modal-header">
                                        <slot name="header">
                                            <button v-for="(t, index) in server_frames"
                                                    type="button" class="btn btn-text btn-fill"
                                                    :class="{ 'active' : t.id === active_frame_category}"
                                                    @click="selectFrameCategory(t.id)">
                                                {{ t.name }}
                                            </button>
                                        </slot>
                                    </div>

                                    <div class="modal-body" style="background: #C9D5DF;">
                                        <slot name="body">
                                            <div v-for="(t, index) in server_frames">
                                                <div v-for="(f, index) in t.data"
                                                     v-if="t.id === active_frame_category"
                                                     class="frame-item"
                                                     @click="addFrame(f)">
                                                    <img :src="`${f.src_full}`" class="image">
                                                </div>
                                            </div>
                                        </slot>
                                    </div>

                                    <div class="modal-footer">
                                        <slot name="footer">
                                            <button class="btn btn-info btn-fill modal-close-button"
                                                    @click="closeFramesModal">
                                                Закрыть
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <div class="loader" v-if="textWaiting"></div>

                            <div class="row">
                                <div class="col-md-4 c-labels" v-if="active_type === 'text' && template && template.texts.length > 0">
                                    <label class="control-label">Текст</label>
                                    <textarea class="text-area"
                                              v-model="template.texts[active_text].text">
                                    </textarea>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      :label="template.texts[active_text].type ? 'Время появления tool (0 - c начала)' : 'Время появления текста (0 - c начала)'"
                                                      v-model="template.texts[active_text].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.texts[active_text].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <img class="widget-icon" :src="`/static/img/widget${template.texts[active_text].type}.png`" v-if="template.texts[active_text].type"/>
                                    <div class="form-group" v-if="template.texts[active_text].type">
                                        <label class="control-label">Тип виджета</label>
                                        <select v-model="template.texts[active_text].type"
                                                id="widget-type-control"
                                                @change="changeWidgetType(active_text, template.texts[active_text].type)"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in widget_types" v-bind:value="f.id">{{ f.name }}</option>
                                        </select>
                                    </div>
                                    <label class="control-label">Размер шрифта: <span
                                        class="param-span">{{ template.texts[active_text].font_size }}</span></label>
                                    <fg-input type="range"
                                              min="5" max="200" step="1"
                                              label=""
                                              v-model="template.texts[active_text].font_size"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.texts[active_text].z_index"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Шрифт</label>
                                        <select v-model="template.texts[active_text].font_name"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in sortedFonts" v-bind:value="f.name">{{ f.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox">По центру по
                                            горизонтали</label>
                                        <input @change="setTextPosition(0.5, null)"
                                               :checked="template.texts[active_text].position_x == 0.5"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position X"
                                                  @input="val => setTextPosition(val, null)"
                                                  v-model="template.texts[active_text].position_x"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="clearfix"></div>
                                        <label for="control2" class="control-label label-checkbox">По центру по
                                            вертикали</label>
                                        <input @change="setTextPosition(null, 0.5)"
                                               :checked="template.texts[active_text].position_y == 0.5"
                                               id="control2" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position Y"
                                                  @input="val => setTextPosition(null, val)"
                                                  v-model="template.texts[active_text].position_y"
                                                  placeholder="">
                                        </fg-input>
                                    </div>
                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.texts[active_text].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].alpha"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox mb10">Text brush</label>
                                        <input v-model="template.texts[active_text].is_text_brush"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                        <label class="control-label" v-if="template.texts[active_text].is_text_brush">Text brush data</label>
                                        <textarea class="text-area" v-if="template.texts[active_text].is_text_brush"
                                                  v-model="template.texts[active_text].text_brush_data">
                                    </textarea>
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот текста (градусы)"
                                              v-model="template.texts[active_text].angle"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межбуквенный интервал"
                                              v-model="template.texts[active_text].letter_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межстрочный интервал"
                                              v-model="template.texts[active_text].line_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Цвет текста: <span class="param-span">{{
                                                template.texts[active_text].text_color
                                            }}</span></label>
                                        <input type="color" v-model="template.texts[active_text].text_color">
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].text_color}"
                                                  @click="setColor(c, 'color')"></span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Цвет фона:
                                            <span class="param-span"
                                                  v-if="template.texts[active_text].background_color === 'transparent'">Прозрачный</span>
                                            <span class="param-span"
                                                  v-else>{{ template.texts[active_text].background_color }}</span>
                                        </label>
                                        <input type="color" v-model="template.texts[active_text].background_color"
                                               v-show="template.texts[active_text].background_color !== 'transparent'">
                                        <div class="clearfix"></div>
                                        <label for="background-control" class="control-label label-checkbox mb10">Прозрачный</label>
                                        <input @change="toggleBackground()"
                                               :checked="template.texts[active_text].background_color === 'transparent'"
                                               id="background-control" class="form-check-inline"
                                               type="checkbox">
                                        <div class="color-set"
                                             v-show="template.texts[active_text].background_color !== 'transparent'">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].background_color}"
                                                  @click="setColor(c, 'background')"></span>
                                        </div>
                                    </div>
                                    <label class="control-label">Прозрачность фона: <span
                                        class="param-span">{{ template.texts[active_text].bg_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].bg_alpha"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label for="animated-control" class="control-label label-checkbox mb10">Анимированный (привязан к кусочку)</label>
                                        <input v-model="template.texts[active_text].is_animated"
                                               true-value="1"
                                               false-value="0"
                                               id="animated-control" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Направление текста</label>
                                        <select v-model="template.texts[active_text].direction"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="normal">normal</option>
                                            <option value="vertical">vertical</option>
                                            <option value="round">round</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.texts[active_text].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{
                                                    t.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-show="template.texts[active_text].animation_type !== 0"
                                           class="control-label">Длительность анимации: <span
                                        class="param-span">{{
                                            template.texts[active_text].animation_duration
                                        }}</span></label>
                                    <fg-input v-show="template.texts[active_text].animation_type !== 0" type="range"
                                              min="0" max="20" step="0.1"
                                              label=""
                                              v-model="template.texts[active_text].animation_duration"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Выравнивание <br>(если больше одной строки)</label>
                                        <select v-model="template.texts[active_text].text_align"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="ta in text_aligns" v-bind:value="ta.name">{{
                                                    ta.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.texts[active_text].shadow_color">
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Сдвиг тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_distance }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].shadow_distance"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].shadow_alpha"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Размер обводки: <span
                                        class="param-span">{{ template.texts[active_text].stroke_size }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].stroke_size"
                                              placeholder="">
                                    </fg-input>
                                    <label for="stroke-color">Цвет обводки:</label>
                                    <input type="color" id="stroke-color"
                                           v-model="template.texts[active_text].stroke_color">
                                    <div class="clearfix"></div>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeText(active_text)">Удалить текст
                                    </button>
                                    <div class="clearfix"></div>

                                </div>


                                <div class="col-md-4 c-labels" v-if="active_type === 'object' && template && template.objects.length > 0">
                                    <button type="button" class="btn btn-text btn-fill active control-btn"
                                            @click="changeObject()">Заменить
                                    </button>
                                    <div class="clearfix"></div>
                                    <label class="control-label">Объект</label>
                                    <img alt="" @click="changeObject()" class="object-preview"
                                         :src="objectPlayerSrc(template.objects[active_object])">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время появления объекта (0 - c начала)"
                                                      v-model="template.objects[active_object].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.objects[active_object].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <fg-input type="text"
                                              label="Размер:"
                                              v-model="template.objects[active_object].scale"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="range"
                                              min="0.03" max="5" step="0.0001"
                                              label=""
                                              v-model="template.objects[active_object].scale"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.objects[active_object].z_index"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label for="control3" class="control-label label-checkbox mb10">По центру по
                                            горизонтали</label>
                                        <input @change="setObjectPosition(0.5, null)"
                                               :checked="template.objects[active_object].position_x == 0.5"
                                               id="control3" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position X"
                                                  @input="val => setObjectPosition(val, null)"
                                                  v-model="template.objects[active_object].position_x"
                                                  placeholder="">
                                        </fg-input>
                                        <div class="clearfix"></div>
                                        <label for="control4" class="control-label label-checkbox mb10">По центру по
                                            вертикали</label>
                                        <input @change="setObjectPosition(null, 0.5)"
                                               :checked="template.objects[active_object].position_y == 0.5"
                                               id="control4" class="form-check-inline"
                                               type="checkbox">
                                        <fg-input type="text"
                                                  label="Position Y"
                                                  @input="val => setObjectPosition(null, val)"
                                                  v-model="template.objects[active_object].position_y"
                                                  placeholder="">
                                        </fg-input>
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.objects[active_object].angle"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group"
                                         v-show="template.objects[active_object].id.indexOf('nocolor') < 0 && !isGifSrc(template.objects[active_object].id)">
                                        <label class="control-label">Цвет: <span class="param-span">{{
                                                template.objects[active_object].color
                                            }}</span></label>
                                        <input type="color" v-model="template.objects[active_object].color">
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.objects[active_object].color}"
                                                  @click="setObjColor(c)"></span>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="object-animated-control" class="control-label label-checkbox mb10">Анимированный (привязан к кусочку)</label>
                                        <input v-model="template.objects[active_object].is_animated"
                                               true-value="1"
                                               false-value="0"
                                               id="object-animated-control" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.objects[active_object].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{
                                                    t.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label v-show="template.objects[active_object].animation_type !== 0"
                                           class="control-label">Длительность анимации: <span
                                        class="param-span">{{
                                            template.objects[active_object].animation_duration
                                        }}</span></label>
                                    <fg-input v-show="template.objects[active_object].animation_type !== 0" type="range"
                                              min="0" max="20" step="0.1"
                                              label=""
                                              v-model="template.objects[active_object].animation_duration"
                                              placeholder="">
                                    </fg-input>

                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.objects[active_object].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.objects[active_object].shadow_color">
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.objects[active_object].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Сдвиг тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_distance }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].shadow_distance"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.objects[active_object].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].shadow_alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Src"
                                              v-model="template.objects[active_object].id"
                                              placeholder="">
                                    </fg-input>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeObject(active_object)">Удалить объект
                                    </button>
                                    <div class="clearfix"></div>

                                </div>

                                <div class="col-md-4 c-labels" v-if="active_type === 'frame' && template && template.frames[active_frame]">
                                    <button type="button" class="btn btn-text btn-fill active control-btn"
                                            @click="changeFrame()">Заменить
                                    </button>
                                    <div class="clearfix"></div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время появления фрейма (0 - c начала)"
                                                      v-model="template.frames[active_frame].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.frames[active_frame].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.frames[active_frame].alpha }}</span></label>

                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.frames[active_frame].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.frames[active_frame].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Ширина слайда в Figma"
                                              v-model="template.frames[active_frame].rawData.original_w"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Ширина фрейма"
                                              v-model="template.frames[active_frame].rawData.w"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Отступ сверху"
                                              v-model="template.frames[active_frame].rawData.y"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Отступ слева"
                                              v-model="template.frames[active_frame].rawData.x"
                                              @input="onFrameRawDataChange"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.frames[active_frame].angle"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Src"
                                              v-model="template.frames[active_frame].src"
                                              placeholder="">
                                    </fg-input>

                                    <div class="clearfix"></div>
                                    <button type="button" class="btn btn-remove"
                                            @click="removeFrame(active_frame)">Удалить фрейм
                                    </button>

                                </div>

                                <div class="col-md-4 c-labels"
                                     v-if="!(active_type === 'text' && template && template.texts.length > 0) &&
                                           !(active_type === 'object' && template && template.objects.length > 0) &&
                                           !(active_type === 'frame' && template && template.frames[active_frame])">
                                </div>

                                <div class="col-md-8">
                                    <div id="preview-container" class="preview-sticky" :style="{ top: layersBarHeight + 'px' }" v-if="template">
                                        <div id="player"
                                             :style="{ height: heightCanvas + 'px' }"
                                             v-show="template.src_full">
                                            <video ref="videoContainer" v-if="!isVideo(template.preview_src_full)"
                                                   controls disablepictureinpicture
                                                   muted
                                                   controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                                   playsinline id="video_player"
                                                   v-bind:poster="template.preview_src_full"
                                                   :style="{ height: heightCanvas + 'px', zIndex: 0 }"
                                                   style="max-width: 100%; cursor: pointer; border: 1px solid red; position: relative; z-index: 0;">
                                                <source v-bind:src="template.src_full"/>
                                            </video>
                                            <video ref="videoContainer" v-if="isVideo(template.preview_src_full)"
                                                   controls disablepictureinpicture
                                                   muted
                                                   controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                                   playsinline id="video_player2"
                                                   :style="{ height: heightCanvas + 'px', zIndex: 0 }"
                                                   style="max-width: 100%; cursor: pointer; border: 1px solid red; position: relative; z-index: 0;">
                                                <source v-bind:src="template.src_full"/>
                                            </video>
                                            <div v-for="(tt, index) in template.texts"
                                                 ref="draggableContainer" class="draggable-container"
                                                 v-if="tt.font_size"
                                                 v-show="tt.is_visible !== 0"
                                                 v-bind:id="`${index}`"
                                                 :style="{ zIndex: tt.z_index }">
                                                <div v-show="tt.is_visible === 1" class="draggable-header" v-if="fonts.length > 1"
                                                     :class="{ active: index === active_text && active_type === 'text' }"
                                                     v-html="text_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                            <div v-for="(tt, index) in template.objects"
                                                 ref="draggableContainer2" class="draggable-container" v-if="tt.scale"
                                                 v-show="tt.is_visible !== 0"
                                                 v-bind:id="`o${index}`"
                                                 :style="{ zIndex: tt.z_index }">
                                                <div v-if="tt.id.indexOf('.svg') > 0" v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     :class="{ active: index === active_object && active_type === 'object' }"
                                                     v-html="object_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                                <div v-if="tt.id.indexOf('.svg') < 0" v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     :class="{ active: index === active_object && active_type === 'object' }"
                                                     v-html="image_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                            <div v-for="(fr, index) in template.frames"
                                                 ref="draggableContainer3" class="draggable-container"
                                                 v-if="fr.layouts"
                                                 v-show="fr.is_visible !== 0"
                                                 v-bind:id="`f${index}`"
                                                 :style="{ zIndex: fr.z_index }">
                                                <div class="draggable-header nospace" v-show="fr.is_visible === 1"
                                                     :class="{ active: index === active_frame && active_type === 'frame' }"
                                                     v-html="frame_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                        </div>

                                        <button type="button" class="btn btn-toggle"
                                                v-bind:class="{ 'active-state': template.src_full }"
                                                @click.prevent="showPreview()">
                                            Показать превью
                                        </button>
                                    </div>

                                </div>


                            </div>

                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
                <div class="col-md-3">
                    <card v-if="template">
                        <h4 slot="header" class="card-title">Параметры видео
                            <div class="realDuration" v-if="realVideoDuration">
                                Длительность из видео:
                                <span :class="{'bg-danger' : Math.abs(this.sumParts - this.realVideoDuration.toFixed(2)) > 0}">{{ realVideoDuration.toFixed(2) }}</span>
                            </div>
<!--                            <div class="realDuration" v-if="realAudioDuration">-->
<!--                                Длительность из аудио:-->
<!--                                <span :class="{'bg-danger' : Math.abs(this.sumParts - this.realAudioDuration.toFixed(2)) > 0}">{{ realAudioDuration.toFixed(2) }}</span>-->
<!--                            </div>-->
                            <div class="partsDuration">
                                Длительность фрагментов:
                            <span :class="{'bg-danger' : Math.abs(this.sumParts - this.template.duration) > 0}">{{ sumParts }}</span>
                            </div>
                        </h4>
                        <div class="loader" v-if="waiting"></div>

                        <form>
                            <div class="row">
                                <div class="col-md-12">
                                    <fg-input type="text"
                                              @input="formatVideoDuration($event)"
                                              label="Длительность, сек."
                                              v-model="template.duration"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Количество фрагментов"
                                              @input="changeVideoCount"
                                              @focusout.native="commitVideoCount"
                                              v-model="template.videos"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group paste-durations">
                                        <label class="control-label">Вставить длительности из таблицы</label>
                                        <textarea class="form-control"
                                                  rows="5"
                                                  v-model="pastedDurations"
                                                  @paste="onPasteDurations"
                                                  @blur="applyPastedDurations"
                                                  :placeholder="'0.53\n0.23\n0.90\n0.90\n1.13'"></textarea>
                                        <div class="paste-durations-hint">
                                            По одному числу в строке. Заголовок и пустые строки пропускаются.
                                            <span v-if="pastedDurationsCount" class="paste-durations-applied">
                                                Заполнено {{ pastedDurationsCount }} кусочков
                                            </span>
                                        </div>
                                        <button type="button"
                                                class="btn btn-info btn-fill btn-sm paste-durations-btn"
                                                @click="applyPastedDurations">
                                            Заполнить
                                        </button>
                                    </div>
                                    <h4 slot="header" class="card-title">Фрагменты
                                    </h4>


                                    <div class="content"
                                         v-for="(itm,index) in visibleClientParts"
                                         :key="index"
                                         :class="{ 'part-empty-duration': isPartDurationInvalid(index) }">
                                        <div class="control">
                                            <div class="part-actions">
                                                <button type="button"
                                                        class="part-action-btn"
                                                        @click.prevent="duplicatePart(index)">Дублировать
                                                </button>
                                                <button type="button"
                                                        class="part-action-btn part-action-delete"
                                                        @click.prevent="removePart(index)">Удалить
                                                </button>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <span class="block-number">{{ index + 1 }}.</span>
                                                </div>
                                                <div class="col-md-3"
                                                     :class="{ 'has-error part-duration-error': isPartDurationInvalid(index) }">
                                                    <fg-input type="text"
                                                              @input="formatDuration($event, index)"
                                                              v-bind:label="`Длительн.`"
                                                              v-model="client_parts[index].duration"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-2">
                                                    <fg-input type="text"
                                                              @input="formatSpeed($event, index)"
                                                              v-bind:label="`Скорость`"
                                                              v-model="client_parts[index].speed"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="control-label">Эффект</label>
                                                        <select v-model="client_parts[index].effect_type"
                                                                @change="changeEffectType(index, client_parts[index].effect_type)"
                                                                id="category-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="e in effect_types" v-bind:value="e.id">
                                                                {{ e.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="template.is_cut_out">
                                                <div class="col-md-2">
                                                    <label for="cut-out-2-control"
                                                           class="control-label label-checkbox">Cutout-кусочек</label>
                                                    <input v-model="client_parts[index].cutout_only" id="cut-out-2-control"
                                                           class="form-check-inline" type="checkbox">
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="control-label">Тип анимации (cutout)</label>
                                                        <select v-model="client_parts[index].cutout_animation_type"
                                                                id="category-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="a in animation_types" v-bind:value="a.id">
                                                                {{ a.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-4" style="padding-right: 15px !important;" v-if="client_parts[index].cutout_only">
                                                    <fg-input type="text"
                                                              @input="formatStartTime($event, index, 'cutout_start_time')"
                                                              v-bind:label="`Время появления (cutout)`"
                                                              v-model="client_parts[index].cutout_start_time"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                            </div>
                                            <div class="row" v-if="template.is_cut_out">
                                                <div class="col-md-12">
                                                    <label class="control-label">Длительность анимации (cutout): <span
                                                        class="param-span">{{
                                                            client_parts[index].cutout_animation_duration
                                                        }}</span></label>
                                                    <fg-input type="range"
                                                              min="0" max="20" step="0.1"
                                                              label=""
                                                              v-model="client_parts[index].cutout_animation_duration"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                            </div>
                                            <div class="row" v-if="client_parts[index].cutout_only">
                                                <div class="effect-values">
                                                    Позиция (cutout)
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="cutout-preview"
                                                         @click="changeCutoutPosition($event, index)">
                                                        <span class="cutout-area"
                                                              :style="{'top': client_parts[index].cutout_y * 87 - 15 + 'px',
                                                                        'left': client_parts[index].cutout_x * 48 - 15 + 'px'}">
                                                            <span class="cutout-center"></span>
                                                        </span>
                                                    </div>
                                                    <span style="padding-left: 9px" class="cutout-position">{{ client_parts[index].cutout_x }}</span>
                                                    <span class="cutout-position">{{ client_parts[index].cutout_y }}</span>
                                                </div>
                                                <div class="col-md-9">
                                                    <div class="row" v-if="template.is_cut_out">
                                                        <div class="col-md-12">
                                                            <label
                                                                class="control-label">Размер (cutout): <span
                                                                class="param-span">{{
                                                                    client_parts[index].cutout_scale
                                                                }}</span></label>
                                                            <fg-input type="range"
                                                                      min="0" max="2" step="0.1"
                                                                      label=""
                                                                      v-model="client_parts[index].cutout_scale"
                                                                      placeholder="">
                                                            </fg-input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
<!--                                            888-->
                                            <div class="row"
                                                 v-bind:class="{ bordered: client_parts[index].effect_type === 0 }">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <button type="button" class="btn btn-text btn-fill active control-btn collage-btn"
                                                                @click="showCollageModal(index)">Коллаж +
                                                        </button>
                                                    </div>
                                                </div>

                                                <div class="col-md-3" v-if="client_parts[index].collage_type">
                                                    <fg-input type="text"
                                                              @input="formatStartTime($event, index, 'start_time')"
                                                              v-bind:label="`Время начала`"
                                                              v-model="client_parts[index].start_time"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4" style="padding-right: 15px !important;">
                                                    <div class="form-group">
                                                        <label class="control-label">Контент</label>
                                                        <select v-model="client_parts[index].content_type"
                                                                @change="changeContentType(index, client_parts[index].content_type)"
                                                                id="content-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="e in content_types" v-bind:value="e.id">
                                                                {{ e.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div class="col-md-6 ml9"
                                                     v-show="client_parts[index].content_type === 1">
                                                    <div>
                                                        <h5 class="card-title">
                                                            Контент: <span v-if="client_parts[index].content">
                                                            <a v-if="isContentCorrected(client_parts[index].content)"
                                                               :href="client_parts[index].content_full" target="_blank">(ссылка)</a></span>
                                                        </h5>

                                                        <div>
                                                            <input :ref="`contentFileInput_${index}`" class="btn-file"
                                                                   type="file"
                                                                   @change="uploadFile($event, 'content', index)">
                                                            <button type="button"
                                                                    class="btn btn-info btn-fill upload-button"
                                                                    @click="clickContentFileButton(index)">
                                                                Загрузить
                                                            </button>
                                                            <div class="clearfix"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 ml9"
                                                     v-show="client_parts[index].content_type === 2">
                                                    <div>
                                                        <div class="form-group">
                                                            <label class="control-label">Фон контента: <span
                                                                class="param-span">{{
                                                                    getContentColor(client_parts[index].content)
                                                                }}</span></label>
                                                            <input type="color" v-model="client_parts[index].content">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row bordered"
                                                 v-if="client_parts[index].collage_type">
                                                <div class="col-md-3">
                                                    <div v-html="renderCollagePart(client_parts[index].collage_type, index)"
                                                         @click="showCollageModal(index)"
                                                         class="collage-preview">
                                                    </div>
<!--                                                    888-->
                                                </div>
                                                <div class="col-md-3"></div>
                                                <div class="col-md-6">
                                                    <button type="button" class="btn btn-danger btn-fill btn-delete-collage"
                                                            @click.prevent="removeCollageFromPart(index)">Удалить коллаж
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="row bordered"
                                                 v-if="(client_parts[index].effect_type === 1 || client_parts[index].effect_type === 2) && client_parts[index].effect_values">
                                                <div class="effect-values">
                                                    {{ effect_types[client_parts[index].effect_type].name }} - Параметры
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="effect-preview"
                                                         @click="changeEffectPosition($event, index)">
                                                        <span class="effect-area"
                                                              :style="{'top': client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': client_parts[index].effect_values.x * 48 - 15 + 'px'}">
                                                            <span class="effect-center"></span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <fg-input type="number" step=0.1
                                                              v-bind:label="`Начальное значение`"
                                                              v-model="client_parts[index].effect_values.from"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <fg-input type="number" step=0.1
                                                              v-bind:label="`Конечное значение`"
                                                              v-model="client_parts[index].effect_values.to"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>


                        </form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const _ = require('lodash')

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import {template} from "lodash";
import {du} from "@fullcalendar/core/internal-common";
import graphics from "../Graphics.vue";
import unsavedLeaveGuard from 'src/mixins/unsavedLeaveGuard'
import replaceGraphicSize from 'src/mixins/replaceGraphicSize'
import gifGraphic from 'src/mixins/gifGraphic'
import stickyLayers from 'src/mixins/stickyLayers'
import pastePartDurations from 'src/mixins/pastePartDurations'

export default {
    name: 'EditCategory',
    mixins: [unsavedLeaveGuard, replaceGraphicSize, gifGraphic, pastePartDurations, stickyLayers],
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            textWaiting: false,
            visibilityRaf: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            show_collage_modal: false,
            show_frames_modal: false,
            is_object_changing: false,
            is_frame_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            active_frame: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            realVideoDuration: null,
            realAudioDuration: null,
            effect: "",
            effect_intensity: 100,
            filter: "",
            filter_intensity: 100,
            heightCanvas: 640,
            active_object_category: null,
            active_frame_category: 1,
            active_collage_category: '2',
            previous_collage_id: null,
            active_part_index: null,
            default_custom_collage_rawData: {
                original_w: 1080,
                original_h: 1920,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0,
            },
            custom_collage_rawData: {
                original_w: 1080,
                original_h: 1920,
                w: 0,
                h: 0,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0,
            },
            tags: [],
            server_effects: [],
            server_graphics: [],
            server_filters: [],
            server_fonts: [],
            server_frames: [],
            svg_sources: [],
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                bg_alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                is_text_brush: 0,
                text_brush_data: [],
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                is_animated: 0,
                angle: 0,
                direction: 'normal',
                shadow_color: '#ffffff',
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_blur: 0,
                animation_type: 0,
                animation_duration: 0,
                stroke_size: 0,
                stroke_color: '#000000',
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                is_animated: 0,
                angle: 0,
                shadow_color: '#ffffff',
                shadow_alpha: 0,
                shadow_distance: 0,
                shadow_blur: 0,
            },
            texts: [],
            objects: [],
            colors: [
                "#FFFFFF",
                "#000000",
                "#F9F7F4",
                "#FAF5ED",
                "#F2E8DD",
                "#F4E4DD",
                "#D9BEBD",
                "#C5AEB6",
                "#E3C2D2",
                "#F1E0EF",
                "#D5C9E9",
                "#C8ACE0",
                "#E06E97",
                "#E64F3C",
                "#AB613E",
                "#B97959",
                "#D99056",
                "#E8BF88",
                "#EDD8AB",
                "#FAE389",
                "#F5C154",
                "#B78C3A",
                "#585B3B",
                "#7B7C41",
                "#BBB595",
                "#DFE7DA",
                "#C0DED3",
                "#B4C5C9",
                "#C9D9F0",
                "#4E63EC",
                "#4F5E8D",
                "#725B6E",
                "#F0F0F0",
                "#D9D9D9",
                "#616161",
                "#3C3C3C",
            ],
            fonts: [
                {
                    params: "'SF Pro', sans-serif;",
                    code: "SF Pro",
                    name: "SF Pro",
                },
            ],
            widget_types: [
                {
                    id: 1,
                    name: "Message (справа)",
                },
                {
                    id: 5,
                    name: "Message (слева)",
                },
                {
                    id: 2,
                    name: "Time",
                },
                {
                    id: 3,
                    name: "Location",
                },
                {
                    id: 4,
                    name: "Custom tag (снизу)",
                },
                {
                    id: 6,
                    name: "Custom tag (сверху)",
                },
                {
                    id: 7,
                    name: "Selection",
                },
            ],
            animation_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Fade",
                },
                {
                    id: 4,
                    name: "Zoom In",
                },
                {
                    id: 31,
                    name: "Zoom Out",
                },
                {
                    id: 6,
                    name: "Reveal ↓",
                },
                {
                    id: 7,
                    name: "Reveal ↑",
                },
                {
                    id: 8,
                    name: "Reveal →",
                },
                {
                    id: 9,
                    name: "Reveal ←",
                },
                {
                    id: 10,
                    name: "Float ↓",
                },
                {
                    id: 11,
                    name: "Float ↑",
                },
                {
                    id: 12,
                    name: "Float →",
                },
                {
                    id: 13,
                    name: "Float ←",
                },
                {
                    id: 14,
                    name: "Typewriter",
                },
                {
                    id: 15,
                    name: "Typewriter Fade In",
                },
                {
                    id: 16,
                    name: "Typewriter By Word",
                },
                {
                    id: 17,
                    name: "Typewriter By Word Fade In",
                },
            ],
            effect_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Zoom in",
                },
                {
                    id: 2,
                    name: "Zoom out",
                },
                {
                    id: 3,
                    name: "Snow",
                },
                {
                    id: 4,
                    name: "VHS",
                },
            ],
            collage_types: [
                {
                    id: 0,
                    name: "-",
                    params: null,
                },
                {
                    id: 1,
                    name: "1/4",
                    params: {x: 0, y: 0, w: 0.5, h: 0.5},
                },
                {
                    id: 2,
                    name: "2/4",
                    params: {x: 0.5, y: 0, w: 0.5, h: 0.5},
                },
                {
                    id: 3,
                    name: "3/4",
                    params: {x: 0, y: 0.5, w: 0.5, h: 0.5},
                },
                {
                    id: 4,
                    name: "4/4",
                    params: {x: 0.5, y: 0.5, w: 0.5, h: 0.5},
                },
                {
                    id: 5,
                    name: "1/3",
                    params: {x: 0, y: 0, w: 1, h: 0.3333},
                },
                {
                    id: 6,
                    name: "2/3",
                    params: {x: 0, y: 0.3333, w: 1, h: 0.3333}
                },
                {
                    id: 7,
                    name: "3/3",
                    params: {x: 0, y: 0.6666, w: 1, h: 0.3333}
                },
                {
                    id: 8,
                    name: "1/2",
                    params: {x: 0, y: 0, w: 1, h: 0.5}
                },
                {
                    id: 9,
                    name: "2/2",
                    params: {x: 0, y: 0.5, w: 1, h: 0.5}
                },
                {
                    id: 10,
                    name: "1/6",
                    params: {x: 0, y: 0, w: 0.5, h: 0.3333},
                },
                {
                    id: 11,
                    name: "2/6",
                    params: {x: 0.5, y: 0, w: 0.5, h: 0.3333},
                },
                {
                    id: 12,
                    name: "3/6",
                    params: {x: 0, y: 0.3333, w: 0.5, h: 0.3333},
                },
                {
                    id: 13,
                    name: "4/6",
                    params: {x: 0.5, y: 0.3333, w: 0.5, h: 0.3333},
                },
                {
                    id: 14,
                    name: "5/6",
                    params: {x: 0, y: 0.6666, w: 0.5, h: 0.3333},
                },
                {
                    id: 15,
                    name: "6/6",
                    params: {x: 0.5, y: 0.6666, w: 0.5, h: 0.3333},
                },
            ],
            content_types: [
                {
                    id: 0,
                    name: "Обычный",
                },
                {
                    id: 1,
                    name: "Статика",
                },
                {
                    id: 2,
                    name: "Цвет",
                },
            ],
            text_aligns: [
                {
                    name: "center",
                },
                {
                    name: "start",
                },
                {
                    name: "end",
                },

            ],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: [],
            frame_positions: [],
            collages: [
                {
                    name: '2',
                    data: [
                        {
                            id: '2_1',
                            frames: [
                                { x: 0, y: 0, width: 1.0, height: 0.5 },
                                { x: 0, y: 0.5, width: 1.0, height: 0.5 },
                            ],
                        },
                        {
                            id: '2_2',
                            frames: [
                                { x: 0, y: 0, width: 1.0, height: 0.491 },
                                { x: 0, y: 0.509, width: 1.0, height: 0.491 },
                            ],
                        },
                        {
                            id: '2_3',
                            frames: [
                                { x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474 },
                                { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474 },
                            ],
                        },
                        {
                            id: '2_4',
                            frames: [
                                { x: 0.0306, y: 0.0177, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.0306, y: 0.5083, width: 0.9388, height: 0.474, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '2_5',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 1.0 },
                                { x: 0.5, y: 0, width: 0.5, height: 1.0 },
                            ],
                        },
                        {
                            id: '2_6',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.315 },
                                { x: 0, y: 0.315, width: 1, height: 0.685 },
                            ],
                        },
                        {
                            id: '2_7',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.685 },
                                { x: 0, y: 0.685, width: 1, height: 0.315 },
                            ],
                        },
                        {
                            id: '2_8',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0.5, width: 0.5, height: 0.5 },
                            ],
                        },
                        {
                            id: '2_9',
                            frames: [
                                { x: 0.2375, y: 0.1223, width: 0.532, height: 0.3647 },
                                { x: 0.2375, y: 0.5133, width: 0.532, height: 0.3647 },
                            ],
                        },
                    ],
                },
                {
                    name: '3',
                    data: [
                        {
                            id: "3_1",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.3333},
                                {x: 0, y: 0.3333, width: 1, height: 0.3334},
                                {x: 0, y: 0.6667, width: 1, height: 0.3333},
                            ],
                        },
                        {
                            id: "3_2",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.326783},
                                {x: 0, y: 0.336758, width: 1, height: 0.326783},
                                {x: 0, y: 0.673216, width: 1, height: 0.326783},
                            ],
                        },
                        {
                            id: "3_3",
                            frames: [
                                {x: 0.028, y: 0.015625, width: 0.944, height: 0.3125},
                                {x: 0.028, y: 0.34375, width: 0.944, height: 0.3125},
                                {x: 0.028, y: 0.671875, width: 0.944, height: 0.3125},
                            ],
                        },
                        {
                            id: "3_4",
                            frames: [
                                {
                                    x: 0.028,
                                    y: 0.015625,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                                {
                                    x: 0.028,
                                    y: 0.34375,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                                {
                                    x: 0.028,
                                    y: 0.671875,
                                    width: 0.944,
                                    height: 0.3125,
                                    crop: {type: "roundedCorner", value: 0.027}
                                },
                            ],
                        },
                        {
                            id: "3_5",
                            frames: [
                                {x: 0, y: 0, width: 0.5, height: 0.3333},
                                {x: 0.5, y: 0.3333, width: 0.5, height: 0.3333},
                                {x: 0, y: 0.6667, width: 0.5, height: 0.3333},
                            ],
                        },
                        {
                            id: "3_6",
                            frames: [
                                {x: 0, y: 0, width: 0.3333, height: 1},
                                {x: 0.3333, y: 0, width: 0.3333, height: 1},
                                {x: 0.6667, y: 0, width: 0.3333, height: 1},
                            ],
                        },
                        {
                            id: "3_7",
                            frames: [
                                {x: 0, y: 0, width: 1, height: 0.5},
                                {x: 0, y: 0.5, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0.5, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_8",
                            frames: [
                                {x: 0, y: 0.5, width: 1, height: 0.5},
                                {x: 0, y: 0, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_9",
                            frames: [
                                {x: 0, y: 0, width: 0.5, height: 0.5},
                                {x: 0.5, y: 0, width: 0.5, height: 0.5},
                                {x: 0, y: 0.5, width: 0.5, height: 0.5},
                            ],
                        },
                        {
                            id: "3_10",
                            frames: [
                                {x: 0.0648, y: 0.064, width: 0.4815, height: 0.28125},
                                {x: 0.0648, y: 0.35925, width: 0.4815, height: 0.28125},
                                {x: 0.0648, y: 0.6564, width: 0.4815, height: 0.28125},
                            ],
                        },
                    ]
                },
                {
                    name: '4',
                    data: [
                        {
                            id: "4_1",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.25 },
                                { x: 0, y: 0.25, width: 1, height: 0.25 },
                                { x: 0, y: 0.5, width: 1, height: 0.25 },
                                { x: 0, y: 0.75, width: 1, height: 0.25 },
                            ],
                        },
                        {
                            id: "4_2",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.24267 },
                                { x: 0, y: 0.25264333, width: 1, height: 0.24267 },
                                { x: 0, y: 0.50498666, width: 1, height: 0.24267 },
                                { x: 0, y: 0.75733, width: 1, height: 0.24267 },
                            ],
                        },
                        {
                            id: "4_3",
                            frames: [
                                { x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875 },
                                { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875 },
                            ],
                        },
                        {
                            id: "4_4",
                            frames: [
                                { x: 0.028, y: 0.015925, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.26201875, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.5081125, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                                { x: 0.028, y: 0.75420625, width: 0.944, height: 0.23016875, crop: { type: "roundedCorner", value: 0.027 } },
                            ],
                        },
                        {
                            id: "4_5",
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0.5, width: 0.5, height: 0.5 },
                            ],
                        },
                        {
                            id: "4_6",
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.4948 },
                                { x: 0.50925, y: 0, width: 0.49075, height: 0.4948 },
                                { x: 0, y: 0.5052, width: 0.49075, height: 0.4948 },
                                { x: 0.50925, y: 0.5052, width: 0.49075, height: 0.4948 },
                            ],
                        },
                        {
                            id: "4_7",
                            frames: [
                                { x: 0.0315, y: 0.017708, width: 0.45925, height: 0.410417 },
                                { x: 0.50925, y: 0.017708, width: 0.45927, height: 0.410417 },
                                { x: 0.0315, y: 0.438542, width: 0.45927, height: 0.410417 },
                                { x: 0.50925, y: 0.438542, width: 0.45927, height: 0.410417 },
                            ],
                        },
                        {
                            id: "4_8",
                            frames: [
                                { x: 0.0407, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.5213, y: 0.022917, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.0407, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                                { x: 0.5213, y: 0.5125, width: 0.438, height: 0.464583, crop: { type: "roundedCorner", value: 0.037 } },
                            ],
                        },
                        {
                            id: "4_9",
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 },
                            ],
                        },
                        {
                            id: "4_10",
                            frames: [
                                { x: 0.01852, y: 0.010717, width: 0.96296, height: 0.48381425 },
                                { x: 0.01852, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                                { x: 0.34568, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                                { x: 0.67284, y: 0.50546875, width: 0.30864, height: 0.48411425 },
                            ],
                        },
                        {
                            id: "4_11",
                            frames: [
                                { x: 0.01852, y: 0.010417, width: 0.400926, height: 0.4843745 },
                                { x: 0.437966, y: 0.010417, width: 0.543514, height: 0.4843745 },
                                { x: 0.01852, y: 0.5052085, width: 0.543514, height: 0.4843745 },
                                { x: 0.580554, y: 0.5052085, width: 0.400926, height: 0.4843745 },
                            ],
                        },
                        {
                            id: "4_12",
                            frames: [
                                { x: 0, y: 0, width: 0.49074, height: 0.4895829967 },
                                { x: 0.50926, y: 0, width: 0.49074, height: 0.4895829967 },
                                { x: 0, y: 0.4999996633, width: 1, height: 0.2447917 },
                                { x: 0, y: 0.7552083, width: 1, height: 0.2447917 },
                            ],
                        },
                    ]
                },
                {
                    name: '5',
                    data: [
                        {
                            id: '5_1',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.2 },
                                { x: 0, y: 0.2, width: 1, height: 0.2 },
                                { x: 0, y: 0.4, width: 1, height: 0.2 },
                                { x: 0, y: 0.6, width: 1, height: 0.2 },
                                { x: 0, y: 0.8, width: 1, height: 0.2 },
                            ],
                        },
                        {
                            id: '5_2',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.1875 },
                                { x: 0, y: 0.203125, width: 1, height: 0.1875 },
                                { x: 0, y: 0.40625, width: 1, height: 0.1875 },
                                { x: 0, y: 0.609375, width: 1, height: 0.1875 },
                                { x: 0, y: 0.8125, width: 1, height: 0.1875 },
                            ],
                        },
                        {
                            id: '5_3',
                            frames: [
                                { x: 0.028, y: 0.015825, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095 },
                                { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095 },
                            ],
                        },
                        {
                            id: '5_4',
                            frames: [
                                { x: 0.028, y: 0.015825, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.2128, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.409675, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.60605, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.028, y: 0.803425, width: 0.944, height: 0.18095, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '5_5',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 1, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.5, height: 0.3334 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_6',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 1 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 1 },
                            ],
                        },
                        {
                            id: '5_7',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 1, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 1, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_8',
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.4947915 },
                                { x: 0, y: 0.5052085, width: 0.49075, height: 0.4947915 },
                                { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.33710567, width: 0.49075, height: 0.32608867 },
                                { x: 0.50927, y: 0.67361134, width: 0.49075, height: 0.32638867 },
                            ],
                        },
                        {
                            id: '5_9',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '5_11',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.5 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.5 },
                                { x: 0.6666, y: 0.5, width: 0.3334, height: 0.5 },
                            ],
                        },
                    ],
                },
                {
                    name: '6',
                    data: [
                        {
                            id: '6_1',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.16697 },
                                { x: 0, y: 0.16637, width: 1, height: 0.16697 },
                                { x: 0, y: 0.33304, width: 1, height: 0.16697 },
                                { x: 0, y: 0.49971, width: 1, height: 0.16697 },
                                { x: 0, y: 0.66638, width: 1, height: 0.16696 },
                                { x: 0, y: 0.83304, width: 1, height: 0.16696 },
                            ],
                        },
                        {
                            id: '6_2',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.16790283, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.33680566, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.50520849, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.67361132, width: 1, height: 0.15798583 },
                                { x: 0, y: 0.84201415, width: 1, height: 0.15798583 },
                            ],
                        },
                        {
                            id: '6_3',
                            frames: [
                                { x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152 },
                                { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152 },
                            ],
                        },
                        {
                            id: '6_4',
                            frames: [
                                { x: 0.01852, y: 0.01016971, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.17500142, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.34001313, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.50493484, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.66985655, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                                { x: 0.01852, y: 0.83477826, width: 0.96296, height: 0.154152, crop: { type: 'roundedCorner', value: 0.027 } },
                            ],
                        },
                        {
                            id: '6_14',
                            frames: [
                                { x: 0, y: 0, width: 0.1667, height: 1 },
                                { x: 0.1667, y: 0, width: 0.1666, height: 1 },
                                { x: 0.3333, y: 0, width: 0.1667, height: 1 },
                                { x: 0.5, y: 0, width: 0.1667, height: 1 },
                                { x: 0.6667, y: 0, width: 0.1666, height: 1 },
                                { x: 0.8333, y: 0, width: 0.1667, height: 1 },
                            ],
                        },
                        {
                            id: '6_5',
                            frames: [
                                { x: 0, y: 0, width: 1, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_6',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0.5, y: 0.3333, width: 0.5, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.5, height: 0.3334 },
                                { x: 0.5, y: 0.6666, width: 0.5, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_7',
                            frames: [
                                { x: 0, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0, width: 0.49075, height: 0.32638867 },
                                { x: 0, y: 0.33685567, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.33685567, width: 0.49075, height: 0.32638867 },
                                { x: 0, y: 0.67321134, width: 0.49075, height: 0.32638867 },
                                { x: 0.50927, y: 0.67321134, width: 0.49075, height: 0.32638867 },
                            ],
                        },
                        {
                            id: '6_8',
                            frames: [
                                { x: 0, y: 0, width: 0.369444, height: 0.25 },
                                { x: 0, y: 0.25, width: 0.369444, height: 0.25 },
                                { x: 0.369444, y: 0, width: 0.630556, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.630556, height: 0.5 },
                                { x: 0.630556, y: 0.5, width: 0.369444, height: 0.25 },
                                { x: 0.630556, y: 0.75, width: 0.369444, height: 0.25 },
                            ],
                        },
                        {
                            id: '6_9',
                            frames: [
                                { x: 0, y: 0, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.2526175, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.505235, width: 0.369444, height: 0.2421475 },
                                { x: 0, y: 0.7578525, width: 0.369444, height: 0.2421475 },
                                { x: 0.387964, y: 0, width: 0.612036, height: 0.4947915 },
                                { x: 0.387964, y: 0.505235, width: 0.612036, height: 0.4947915 },
                            ],
                        },
                        {
                            id: '6_10',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.65833 },
                                { x: 0, y: 0.65833, width: 0.3333, height: 0.34167 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.34167 },
                                { x: 0.3333, y: 0.34167, width: 0.3333, height: 0.65833 },
                                { x: 0.6666, y: 0, width: 0.3334, height: 0.65833 },
                                { x: 0.6666, y: 0.65833, width: 0.3334, height: 0.34167 },
                            ],
                        },
                        {
                            id: '6_11',
                            frames: [
                                { x: 0, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0.33950667, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0.67851334, y: 0, width: 0.32098667, height: 0.32638867 },
                                { x: 0, y: 0.33685867, width: 0.32098667, height: 0.32638867 },
                                { x: 0, y: 0.67321734, width: 0.32098667, height: 0.32638867 },
                                { x: 0.33950667, y: 0.33685867, width: 0.66049333, height: 0.66314133 },
                            ],
                        },
                        {
                            id: '6_12',
                            frames: [
                                { x: 0, y: 0, width: 0.68611, height: 0.3333 },
                                { x: 0.68611, y: 0, width: 0.31389, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.31389, height: 0.3333 },
                                { x: 0.31389, y: 0.3333, width: 0.68611, height: 0.3333 },
                                { x: 0, y: 0.6666, width: 0.68611, height: 0.3334 },
                                { x: 0.68611, y: 0.6666, width: 0.31389, height: 0.3334 },
                            ],
                        },
                        {
                            id: '6_13',
                            frames: [
                                { x: 0.084185, y: 0.14375, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.14375, width: 0.391667, height: 0.22013867 },
                                { x: 0.084185, y: 0.38993067, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.38993067, width: 0.391667, height: 0.22013867 },
                                { x: 0.084185, y: 0.63611134, width: 0.391667, height: 0.22013867 },
                                { x: 0.522148, y: 0.63611134, width: 0.391667, height: 0.22013867 },
                            ],
                        },
                    ],
                },
                {
                    name: '9',
                    data: [
                        {
                            id: '9_1',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0.6666, y: 0, width: 0.3333, height: 0.3333 },
                                { x: 0, y: 0.3333, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.3333, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.3333, width: 0.3333, height: 0.3334 },
                                { x: 0, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.3333, y: 0.6666, width: 0.3333, height: 0.3334 },
                                { x: 0.6666, y: 0.6666, width: 0.3333, height: 0.3334 },
                            ],
                        },
                    ],
                },
                {
                    name: '10',
                    data: [
                        {
                            id: '10_1',
                            frames: [
                                { x: 0, y: 0, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.2, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.2, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.4, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.4, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.6, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.6, width: 0.5, height: 0.2 },
                                { x: 0, y: 0.8, width: 0.5, height: 0.2 },
                                { x: 0.5, y: 0.8, width: 0.5, height: 0.2 },
                            ],
                        },
                        {
                            id: '10_2',
                            frames: [
                                { x: 0, y: 0, width: 0.2, height: 0.5 },
                                { x: 0, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.2, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.2, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.4, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.4, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.6, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.6, y: 0.5, width: 0.2, height: 0.5 },
                                { x: 0.8, y: 0, width: 0.2, height: 0.5 },
                                { x: 0.8, y: 0.5, width: 0.2, height: 0.5 },
                            ],
                        },
                    ],
                },
                {
                    name: '12',
                    data: [
                        {
                            id: '12_1',
                            frames: [
                                { x: 0, y: 0, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0, width: 0.3333, height: 0.25 },

                                { x: 0, y: 0.25, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0.25, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0.25, width: 0.3333, height: 0.25 },

                                { x: 0, y: 0.5, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0.5, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0.5, width: 0.3333, height: 0.25 },

                                { x: 0, y: 0.75, width: 0.3333, height: 0.25 },
                                { x: 0.3333, y: 0.75, width: 0.3333, height: 0.25 },
                                { x: 0.6666, y: 0.75, width: 0.3333, height: 0.25 },
                            ],
                        },
                    ],
                },
                {
                    name: '20',
                    data: [
                        {
                            id: '20_1',
                            frames: [
                                { x: 0, y: 0, width: 0.25, height: 0.2 },
                                { x: 0.25, y: 0, width: 0.25, height: 0.2 },
                                { x: 0.5, y: 0, width: 0.25, height: 0.2 },
                                { x: 0.75, y: 0, width: 0.25, height: 0.2 },
                                { x: 0, y: 0.2, width: 0.25, height: 0.2 },
                                { x: 0.25, y: 0.2, width: 0.25, height: 0.2 },
                                { x: 0.5, y: 0.2, width: 0.25, height: 0.2 },
                                { x: 0.75, y: 0.2, width: 0.25, height: 0.2 },
                                { x: 0, y: 0.4, width: 0.25, height: 0.2 },
                                { x: 0.25, y: 0.4, width: 0.25, height: 0.2 },
                                { x: 0.5, y: 0.4, width: 0.25, height: 0.2 },
                                { x: 0.75, y: 0.4, width: 0.25, height: 0.2 },
                                { x: 0, y: 0.6, width: 0.25, height: 0.2 },
                                { x: 0.25, y: 0.6, width: 0.25, height: 0.2 },
                                { x: 0.5, y: 0.6, width: 0.25, height: 0.2 },
                                { x: 0.75, y: 0.6, width: 0.25, height: 0.2 },
                                { x: 0, y: 0.8, width: 0.25, height: 0.2 },
                                { x: 0.25, y: 0.8, width: 0.25, height: 0.2 },
                                { x: 0.5, y: 0.8, width: 0.25, height: 0.2 },
                                { x: 0.75, y: 0.8, width: 0.25, height: 0.2 },
                            ],
                        },
                    ],
                }
            ],
        }
    },
    watch: {
        is_playing(val) {
            if (val) {
                this.startVisibilityLoop();
            } else {
                this.stopVisibilityLoop();
            }
        },
    },
    beforeDestroy: function () {
        this.stopVisibilityLoop();
        document.removeEventListener('keydown', this._nudgeKeydownHandler, true);
    },
    created: function () {
        let self = this;
        self.id = this.$route.params.id;

        self.getResources();

        self.get(self.id);

        self._nudgeKeydownHandler = self.onNudgeKeydown.bind(self);
        document.addEventListener('keydown', self._nudgeKeydownHandler, true);
    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
        fontsUrl() {
            return this.$fontsUrl
        },
        framesUrl() {
            return this.$framesUrl
        },
        sumParts() {
            let sum = 0;
            _.map(this.visibleClientParts, (p) => {
                if (!p.cutout_only) {
                    let duration = parseFloat(p.duration);
                    duration = isNaN(duration) ? 0 : duration;

                    // Collages block
                    if (p.collage_type !== 0) {
                        let startTime = parseFloat(p.start_time);
                        startTime = isNaN(startTime) ? 0 : startTime;

                        let collageDuration = startTime + duration;
                        duration = sum > collageDuration ? 0 : collageDuration - sum;
                    }

                    sum += duration;
                }
            })

            return sum.toFixed(2);
        },
        sortedFonts() {
            return _.sortBy(this.fonts, (f) => {
                return f.name;
            });
        },
        versions() {
            const result = []
            const start = 101
            const end = start + 19

            for (let i = start; i <= end; i++) {
                result.push((i / 10).toFixed(1))
            }

            return result
        },
        collageModalFrameText() {
            let frame = null;

            if (this.active_collage_category === 'Custom') {
                frame = this.buildCustomCollageFrame(false);
            } else if (this.active_part_index !== null && this.client_parts[this.active_part_index]) {
                frame = this.client_parts[this.active_part_index].frame;
            }

            if (!frame) {
                return '';
            }

            return JSON.stringify(frame).replace(/:/g, ': ').replace(/,/g, ', ');
        },
    },
    methods: {
        text_html(index) {
            let textModel = this.template.texts[index];

            let text = _.find(this.fonts, (f) => f.name === textModel.font_name);
            if (!text) {
                alert('Шрифт ' + textModel.font_name + ' не найден. Пожалуйста, замените на другой.');

                text = _.first(this.fonts);
            }

            let line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            let alpha = textModel.alpha;

            let bgColor = textModel.background_color

            if (parseFloat(textModel.bg_alpha) < 0.99) {
                bgColor = textModel.background_color + `${textModel.bg_alpha * 100}`;
            }

            let direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' +
                    '  text-orientation: upright;\n'
            }

            let offset = 4 / 88 * textModel.font_size;
            let blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            let shadow = `text-shadow: ${offset}px ${offset}px ${blur}px ${textModel.shadow_color}${this.convertAlphaToHex(textModel.shadow_alpha)};`;

            return '<span style="color: ' + textModel.text_color + '; ' +
                'background-color: ' + bgColor + '; ' +
                'font-size: ' + textModel.font_size + 'px; ' +
                'letter-spacing: ' + textModel.letter_spacing + 'px; ' +
                'opacity: ' + alpha + '; ' +
                'line-height: ' + line_height + 'px; ' +
                'transform: rotate( ' + textModel.angle + 'deg); ' +
                'display: block;' +
                direction +
                shadow +
                'text-align: ' + textModel.text_align + '; ' +
                'z-index: ' + textModel.z_index + '; ' +
                'font-family:' + text.params + ';">'
                + textModel.text + '</span>';

        },
        object_html(index) {
            return this.renderSvgObjectHtml(this.template.objects[index]);
        },
        frame_html(index) {
            let frameModel = this.template.frames[index];
            if (!frameModel) {
                return "";
            }

            let rawData = frameModel.rawData || {};
            let originalW = parseFloat(rawData.original_w);
            if (!Number.isFinite(originalW) || originalW <= 0) {
                originalW = 1080;
            }

            let scale = 360 / originalW;
            let rawW = parseFloat(rawData.w);
            let width = Number.isFinite(rawW) ? rawW * scale : (parseFloat(frameModel.w) || 1) * 360;

            let img = `<img src="${this.framesUrl}${frameModel.src}">`;

            let style = ` style="width: ${width}px; opacity: ${frameModel.alpha}; padding: 0px; transform: rotate(${frameModel.angle}deg); z-index: ${frameModel.z_index}; display: block;"`;

            img = this.insertAt(img, style, 5)

            return img;
        },
        image_html(index) {
            let objectModel = this.template.objects[index];

            if (!objectModel.source || !objectModel.dimensions) {
                return "";
            }

            let width = objectModel.dimensions.width;
            let height = objectModel.dimensions.height;

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            let img = `<img src="${this.objectPlayerSrc(objectModel)}">`;

            let style = ` style="width: ${width}px; height: ${height}px; opacity: ${objectModel.alpha}; padding: 0px; transform: rotate(${objectModel.angle}deg); z-index: ${objectModel.z_index}; display: block;"`;

            img = this.insertAt(img, style, 5)

            return img;
        },
        isVideo: function (url) {
            return url.indexOf('.mp4') > -1;
        },
        getUnsavedState() {
            return this.stringifyUnsaved({
                template: this.template,
                client_parts: this.client_parts,
                effect: this.effect,
                effect_intensity: this.effect_intensity,
                filter: this.filter,
                filter_intensity: this.filter_intensity
            })
        },
        goBack: function () {
            this.$router.push('/templates');
        },
        insertAt(str, sub, pos) {
            return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
        },
        formatStartTime(event, index, object) {
            this.client_parts[index][object] = this.client_parts[index][object].replace(',', '.')
        },
        formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.')
        },
        formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.')
        },
        formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.')
        },
        addText(copy = false, tool = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedText = JSON.parse(JSON.stringify(self.template.texts[self.active_text]));
                copiedText.z_index = self.template.texts.length + self.template.objects.length + 1;
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                let positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(JSON.stringify(positions)));

                setTimeout(() => {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                let newText = JSON.parse(JSON.stringify(self.default_text));

                if (tool) {
                    newText.type = 1;
                    newText.background_color = '#448AF7';
                }

                newText.z_index = self.template.texts.length + self.template.objects.length + 1;
                self.template.texts.push(newText);
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';

            }

        },
        addObject(object, copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedObject = JSON.parse(JSON.stringify(self.template.objects[self.active_object]));
                copiedObject.z_index = self.template.texts.length + self.template.objects.length + 1;

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(JSON.stringify(self.object_positions[self.active_object])));

                setTimeout(() => {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object'

                }, 100);
            } else {
                self.placeGraphicObject(object);
            }


        },
        changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        changeFrame() {
            this.is_frame_changing = true;
            this.show_frames_modal = true;
        },
        addCollage(e) {
            // 888
            let data = e.target.dataset.params;
            let params = data.split(';');
            let id = params[0];
            let part = params[1]
            let x = params[2]
            let y = params[3]
            let w = params[4]
            let h = params[5]

            this.client_parts[this.active_part_index].collage_type = `${id};${part}`;
            this.client_parts[this.active_part_index].frame = {
                x: parseFloat(x),
                y: parseFloat(y),
                w: parseFloat(w),
                h: parseFloat(h)
            };

            this.previous_collage_id = id;

            this.show_collage_modal = false;
        },
        addCustomCollage() {
            let frame = this.buildCustomCollageFrame(true);

            if (!frame) {
                alert('Заполните размеры фрейма и редактируемой области');
                return;
            }

            this.client_parts[this.active_part_index].collage_type = 'custom';
            this.client_parts[this.active_part_index].frame = frame;

            this.previous_collage_id = 'custom';
            this.show_collage_modal = false;
        },
        buildCustomCollageFrame(withRawData = true) {
            let raw = this.custom_collage_rawData;
            let originalW = parseFloat(raw.original_w);
            let originalH = parseFloat(raw.original_h);
            let w = parseFloat(raw.w);
            let h = parseFloat(raw.h);
            let x = parseFloat(raw.x) || 0;
            let y = parseFloat(raw.y) || 0;
            let bTl = parseFloat(raw.b_tl) || 0;
            let bTr = parseFloat(raw.b_tr) || 0;
            let bBr = parseFloat(raw.b_br) || 0;
            let bBl = parseFloat(raw.b_bl) || 0;

            if (!originalW || !originalH || !w || !h) {
                return null;
            }

            let frame = {
                w: parseFloat((w / originalW).toFixed(6)),
                h: parseFloat((h / originalH).toFixed(6)),
                x: parseFloat((x / originalW).toFixed(6)),
                y: parseFloat((y / originalH).toFixed(6)),
                b_tl: parseFloat((bTl / w).toFixed(6)),
                b_tr: parseFloat((bTr / w).toFixed(6)),
                b_br: parseFloat((bBr / w).toFixed(6)),
                b_bl: parseFloat((bBl / w).toFixed(6)),
            };

            if (withRawData) {
                frame.rawData = JSON.parse(JSON.stringify(raw));
            }

            return frame;
        },
        convertCollageTypeToNewFormat(oldType) {

            if (oldType === 'custom') return oldType;
            if (oldType.toString().indexOf('_') > 0) return oldType;

            let oldTypeName = _.find(this.collage_types, (c) => c.id === parseInt(oldType)).name
            let oldCategory = oldTypeName.split('/');
            let collageCategory = parseInt(oldCategory[1]) === 6 ? 6 : 1;

            return `${oldCategory[1]}_${collageCategory};${oldCategory[0]}`;
        },
        convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectFrame(frame) {
            this.active_frame = frame;
            this.active_type = 'frame';
        },
        selectFrameCategory(id) {
            this.active_frame_category = id;
        },
        addFrame(frame, copy = false) {
            let self = this;

            if (!self.template.frames) {
                self.template.frames = [];
            }

            if (copy !== false) {
                let copiedFrame = JSON.parse(JSON.stringify(self.template.frames[self.active_frame]));

                self.template.frames.push(copiedFrame);
                self.frame_positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);

                self.$nextTick(() => {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            } else if (self.is_frame_changing) {
                let current = self.template.frames[self.active_frame];
                current.id = frame.id;
                current.src = frame.src;
                current.layouts = frame.layouts;
                self.is_frame_changing = false;
                self.show_frames_modal = false;
            } else {
                self.template.frames.push({
                    id: frame.id,
                    src: frame.src,
                    z_index: 1,
                    angle: 0,
                    alpha: 1,
                    layouts: frame.layouts,
                    w: 0,
                    x: 0,
                    y: 0,
                    time_start: 0,
                    time_end: "",
                    is_visible: 1,
                    rawData: {
                        original_w: 1080,
                        w: 540,
                        x: 0,
                        y: 0,
                    }
                });

                self.frame_positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                self.active_frame = self.template.frames.length - 1;
                self.active_type = 'frame';
                self.syncFrameCalculations(self.active_frame);
                self.show_frames_modal = false;

                self.$nextTick(() => {
                    self.applyFrameContainerPosition(self.active_frame);
                });
            }
        },
        removeFrame(index) {
            let self = this;

            if (confirm("Подтверждение удаления фрейма " + (parseInt(index) + 1))) {
                self.template.frames = self.template.frames.filter((t, i) => i !== index);
                self.frame_positions = self.frame_positions.filter((t, i) => i !== index);
                self.active_frame = 0;
                self.syncOverlayActiveType();
            }
        },
        calculateFrames: function() {
            let frames = this.template.frames || [];
            for (let j = 0; j < frames.length; j++) {
                this.syncFrameCalculations(j);
            }
        },
        syncFrameCalculations(index) {
            let frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return;
            }

            let originalH = this.getOriginalH(frame.rawData.original_w);

            frame.w = parseFloat(parseFloat(frame.rawData.w) / parseFloat(frame.rawData.original_w)).toFixed(6)
            frame.x = parseFloat(parseFloat(frame.rawData.x) / parseFloat(frame.rawData.original_w)).toFixed(6)
            frame.y = parseFloat(parseFloat(frame.rawData.y) / parseFloat(originalH)).toFixed(6)
        },
        applyFrameContainerPosition(index) {
            let frame = this.template.frames[index];
            let containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            let scale = 360 / parseFloat(frame.rawData.original_w);
            containers[index].style.left = (parseFloat(frame.rawData.x) * scale) + 'px';
            containers[index].style.top = (parseFloat(frame.rawData.y) * scale) + 'px';
        },
        onFrameRawDataChange() {
            this.syncFrameCalculations(this.active_frame);
            this.applyFrameContainerPosition(this.active_frame);
        },
        updateFramePositionFromDom(index) {
            let frame = this.template.frames[index];
            let containers = this.$refs.draggableContainer3;
            if (!frame || !frame.rawData || !containers || !containers[index]) {
                return;
            }

            let scale = 360 / parseFloat(frame.rawData.original_w);
            frame.rawData.x = parseFloat((containers[index].offsetLeft / scale).toFixed(2));
            frame.rawData.y = parseFloat((containers[index].offsetTop / scale).toFixed(2));
            this.syncFrameCalculations(index);
        },
        getOriginalH(originalW) {
            originalW = parseFloat(originalW);
            let ratio = parseInt(this.template.ratio);

            if (ratio === 2) {
                // Горизонтальный 16:9
                return originalW * 9 / 16;
            }

            if (ratio === 3) {
                // Горизонтальный 5:1
                return originalW / 5;
            }

            // Обычный 9:16
            return originalW / 9 * 16;
        },
        selectObjectCategory(category) {
            this.active_object_category = category;
        },
        selectCollageCategory(category) {
            this.active_collage_category = category;
        },
        removeCollageFromPart(index) {
            let self = this;

            if (confirm("Подтверждение удаления коллажа")) {
                self.client_parts[index].collage_type = 0;
                self.client_parts[index].frame = null;
            }

        },
        removeText(index) {
            let self = this;

            if (confirm("Подтверждение удаления текста: " + self.template.texts[index].text)) {
                self.template.texts = self.template.texts.filter((t, i) => i !== index);
                self.active_text = 0;
                self.syncOverlayActiveType();
            }
        },
        removeObject(index) {
            let self = this;

            if (confirm("Подтверждение удаления объекта")) {
                self.template.objects = self.template.objects.filter((t, i) => i !== index);
                self.active_object = 0;
                self.syncOverlayActiveType();
            }
        },
        syncOverlayActiveType() {
            let self = this;

            if (self.template.texts.length > 0) {
                self.active_type = 'text';
                self.active_text = Math.min(self.active_text, self.template.texts.length - 1);
            } else if (self.template.objects.length > 0) {
                self.active_type = 'object';
                self.active_object = Math.min(self.active_object, self.template.objects.length - 1);
            } else if ((self.template.frames || []).length > 0) {
                self.active_type = 'frame';
                self.active_frame = Math.min(self.active_frame, self.template.frames.length - 1);
            } else {
                self.active_type = 'text';
            }
        },
        toggleText() {
            let self = this;

            if (self.is_text_active) {
                self.active_type = 'text';

                setTimeout(() => {
                    self.video = self.$refs.videoContainer;
                    if (!self.video) return;

                    self.video.addEventListener("playing", function () {
                        //console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        //console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });

                }, 500);
            } else {
                self.template.texts = [];
                self.template.objects = [];
                self.template.frames = [];
                self.positions = [];
                self.frame_positions = [];
            }
        },
        toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },
        setTextPosition: function (x, y) {
            // x = parseFloat(x);
            // y = parseFloat(y);

            if (x) {
                this.template.texts[this.active_text].position_x = x;

                let centerX = x * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                let centerY = y * this.heightCanvas - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function (x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;
            }

            this.applyObjectContainerPosition(this.active_object);
        },
        onNudgeKeydown: function (event) {
            if (!this.template) {
                return;
            }

            if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
                return;
            }

            let target = event.target;
            let tag = target && target.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (target && target.isContentEditable)) {
                return;
            }

            if (this.show_svg_modal || this.show_frames_modal || this.show_collage_modal) {
                return;
            }

            let dx = 0;
            let dy = 0;
            if (event.key === 'ArrowLeft') {
                dx = -1;
            } else if (event.key === 'ArrowRight') {
                dx = 1;
            } else if (event.key === 'ArrowUp') {
                dy = -1;
            } else if (event.key === 'ArrowDown') {
                dy = 1;
            }

            if (!this.nudgeSelectedLayer(dx, dy)) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
        },
        nudgeSelectedLayer: function (dx, dy) {
            if (this.active_type === 'text') {
                return this.nudgeText(dx, dy);
            }
            if (this.active_type === 'object') {
                return this.nudgeObject(dx, dy);
            }
            if (this.active_type === 'frame') {
                return this.nudgeFrame(dx, dy);
            }
            return false;
        },
        nudgeText: function (dx, dy) {
            let index = this.active_text;
            let text = this.template.texts[index];
            let containers = this.$refs.draggableContainer;
            if (!text || !containers || !containers[index]) {
                return false;
            }

            let step = 0.0005;
            text.position_x = parseFloat((parseFloat(text.position_x) + dx * step).toFixed(4));
            text.position_y = parseFloat((parseFloat(text.position_y) + dy * step).toFixed(4));

            let el = containers[index];
            el.style.left = (text.position_x * 360 - el.clientWidth / 2) + 'px';
            el.style.top = (text.position_y * this.heightCanvas - el.clientHeight / 2) + 'px';
            return true;
        },
        nudgeObject: function (dx, dy) {
            let index = this.active_object;
            let obj = this.template.objects[index];
            if (!obj) {
                return false;
            }

            let step = 0.0005;
            obj.position_x = parseFloat((parseFloat(obj.position_x) + dx * step).toFixed(4));
            obj.position_y = parseFloat((parseFloat(obj.position_y) + dy * step).toFixed(4));
            this.applyObjectContainerPosition(index);
            return true;
        },
        nudgeFrame: function (dx, dy) {
            let index = this.active_frame;
            let frame = this.template.frames[index];
            if (!frame || !frame.rawData) {
                return false;
            }

            frame.rawData.x = parseFloat((parseFloat(frame.rawData.x) + dx).toFixed(2));
            frame.rawData.y = parseFloat((parseFloat(frame.rawData.y) + dy).toFixed(2));
            this.syncFrameCalculations(index);
            this.applyFrameContainerPosition(index);
            return true;
        },
        changeEffectType: function (index, type) {

            if (type !== 1 || type !== 2) {
                return;
            }

            let from = 1;
            let to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            }

        },
        changeContentType: function (index, type) {
            this.client_parts[index].content = type === 2 ? '#000000' : null;
        },
        changeRatioType() {
            this.heightCanvas = 640;
            let ratio = parseInt(this.template.ratio);

            if (ratio > 1) {
                this.heightCanvas = ratio === 2 ? 202.5 : ratio === 3 ? 72 : 640;
            }

        },
        changeEffectPosition: function (event, index) {
            let offsetX;
            let offsetY;

            if (event.target.className !== 'effect-preview') {
                let parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;

                } else {

                }

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        changeCutoutPosition: function (event, index) {
            let offsetX;
            let offsetY;

            if (event.target.className !== 'cutout-preview') {
                let parent = event.target.parentElement;
                if (parent.className !== 'cutout-preview') {
                    parent = parent.parentElement;

                } else {

                }

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].cutout_x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].cutout_x > 1) {
                this.client_parts[index].cutout_x = 1;
            }

            this.client_parts[index].cutout_y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].cutout_y > 1) {
                this.client_parts[index].cutout_y = 1;
            }

            this.$forceUpdate();
        },
        refreshTags: function () {
            _.map(this.tags, (t) => {
                t.active = this.template.tags.indexOf(t.id) > -1;
            })
        },
        toggleTag: function (tag) {
            let tags = this.template.tags;
            let index = tags.indexOf(tag.id)
            index > -1 ? tags.splice(index, 1) : tags.push(tag.id);

            this.refreshTags()
        },
        setColor: function (color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        changeWidgetType(index, type) {
            const current = (this.template.texts[this.active_text].background_color || '').toUpperCase();
            const isCustom = current && current !== 'TRANSPARENT' && current !== '#448AF7' && current !== '#888888';
            if (isCustom) {
                return;
            }
            if (type === 1 || type === 5 || type === 7) {
                this.template.texts[this.active_text].background_color = '#448AF7';
            }
            if (type === 2 || type === 3 || type === 4 || type === 6) {
                this.template.texts[this.active_text].background_color = '#888888';
            }
        },
        getContentColor: function (color) {
            if (color && color[0] === '#') {
                return color;
            } else {
                return '#000000'
            }
        },
        isContentCorrected: function (content) {
            return content && content[0] !== '#';
        },
        setObjColor: function (color) {
            this.template.objects[this.active_object].color = color;
        },
        showPreview: function () {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        isEmptyTimeEnd: function (value) {
            return value === "" || value === null || value === undefined;
        },
        normalizeTimeEnd: function (value) {
            if (this.isEmptyTimeEnd(value)) {
                return "";
            }
            let parsed = parseFloat(value);
            return Number.isFinite(parsed) ? parsed : "";
        },
        isElementVisibleAt: function (element, currentTime) {
            if (currentTime === 0) {
                return true;
            }

            let start = parseFloat(element.time_start);
            if (!Number.isFinite(start)) {
                start = 0;
            }

            if (this.isEmptyTimeEnd(element.time_end)) {
                return start < currentTime;
            }

            let end = parseFloat(element.time_end);
            if (!Number.isFinite(end)) {
                return start < currentTime;
            }

            return start < currentTime && end > currentTime;
        },
        checkElementsVisibility: function (currentTime) {
            let self = this;
            let time = parseFloat(currentTime);
            if (!Number.isFinite(time)) {
                time = 0;
            }

            let elements = [self.template.texts, self.template.objects, self.template.frames];
            for (let o = 0; o < elements.length; o++) {
                let element = elements[o];
                if (!element) {
                    continue;
                }

                for (let i = 0; i < element.length; i++) {
                    if (!element[i]) {
                        continue;
                    }

                    self.$set(element[i], 'is_visible', self.isElementVisibleAt(element[i], time) ? 1 : 0);
                }
            }
        },
        stopVisibilityLoop: function () {
            if (this.visibilityRaf) {
                cancelAnimationFrame(this.visibilityRaf);
                this.visibilityRaf = null;
            }
        },
        startVisibilityLoop: function () {
            let self = this;

            this.stopVisibilityLoop();

            let tick = function () {
                if (!self.is_playing) {
                    self.visibilityRaf = null;
                    return;
                }

                if (self.video) {
                    self.checkElementsVisibility(self.video.currentTime);
                }

                self.visibilityRaf = requestAnimationFrame(tick);
            };

            this.visibilityRaf = requestAnimationFrame(tick);
        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/templates/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(async function (response) {

                    let data = response.data;

                    for (let i = 0; i < data.templates[0].texts.length; i++) {

                        let text = _.find(self.fonts, (f) => f.name === data.templates[0].texts[i].font_name);
                        if (!text) {
                            //alert('Шрифт ' + data.templates[0].texts[i].font_name + ' не найден. Пожалуйста, замените на другой.');
                        }

                        data.templates[0].texts[i].is_visible = 1;
                        if (data.templates[0].texts[i].time_start === undefined) {
                            data.templates[0].texts[i].time_start = 0;
                        }
                        if (self.isEmptyTimeEnd(data.templates[0].texts[i].time_end)) {
                            data.templates[0].texts[i].time_end = "";
                        }

                        if (!data.templates[0].texts[i].direction) {
                            data.templates[0].texts[i].direction = "normal";
                        }

                        if (!data.templates[0].texts[i].animation_type) {
                            data.templates[0].texts[i].animation_type = 0;
                            data.templates[0].texts[i].animation_duration = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_blur) {
                            data.templates[0].texts[i].shadow_blur = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_alpha) {
                            data.templates[0].texts[i].shadow_alpha = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_distance) {
                            data.templates[0].texts[i].shadow_distance = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_color) {
                            data.templates[0].texts[i].shadow_color = '#ffffff';
                        }

                        if (!data.templates[0].texts[i].stroke_size) {
                            data.templates[0].texts[i].stroke_size = 0;
                        }

                        if (!data.templates[0].texts[i].stroke_size) {
                            data.templates[0].texts[i].stroke_color = '#000000';
                        }

                        if (!data.templates[0].texts[i].is_text_brush) {
                            data.templates[0].texts[i].text_brush_data = [];
                        }

                        if (!data.templates[0].texts[i].bg_alpha) {
                            data.templates[0].texts[i].bg_alpha = 1;
                        }

                        if (!data.templates[0].texts[i].is_animated) {
                            data.templates[0].texts[i].is_animated = 0;
                        }

                    }

                    for (let i = 0; i < data.templates[0].objects.length; i++) {
                        data.templates[0].objects[i].is_visible = 1;
                        if (data.templates[0].objects[i].time_start === undefined || data.templates[0].objects[i].time_start === null) {
                            data.templates[0].objects[i].time_start = 0;
                        }
                        if (self.isEmptyTimeEnd(data.templates[0].objects[i].time_end)) {
                            data.templates[0].objects[i].time_end = "";
                        }

                        if (!data.templates[0].objects[i].animation_type) {
                            data.templates[0].objects[i].animation_type = 0;
                            data.templates[0].objects[i].animation_duration = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_blur) {
                            data.templates[0].objects[i].shadow_blur = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_alpha) {
                            data.templates[0].objects[i].shadow_alpha = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_distance) {
                            data.templates[0].objects[i].shadow_distance = 0;
                        }

                        if (!data.templates[0].objects[i].shadow_color) {
                            data.templates[0].objects[i].shadow_color = '#ffffff';
                        }

                        if (!data.templates[0].objects[i].is_animated) {
                            data.templates[0].objects[i].is_animated = 0;
                        }

                    }

                    if (!data.templates[0].frames) {
                        data.templates[0].frames = [];
                    }

                    for (let i = 0; i < data.templates[0].frames.length; i++) {
                        data.templates[0].frames[i].is_visible = 1;
                        if (data.templates[0].frames[i].time_start === undefined || data.templates[0].frames[i].time_start === null) {
                            data.templates[0].frames[i].time_start = 0;
                        }
                        if (self.isEmptyTimeEnd(data.templates[0].frames[i].time_end)) {
                            data.templates[0].frames[i].time_end = "";
                        }
                        if (!data.templates[0].frames[i].rawData) {
                            data.templates[0].frames[i].rawData = {
                                original_w: 1080,
                                w: 540,
                                x: 0,
                                y: 0,
                            };
                        }
                    }

                     self.template = JSON.parse(JSON.stringify(data.templates[0]));

                    self.template.parts.forEach((p) => {
                        self.client_parts.push({
                            duration: p.duration,
                            speed: p.speed ? p.speed : "1.0",
                            effect_type: p.effect_type ? p.effect_type : 0,
                            effect_values: p.effect_values ? p.effect_values : {x: 0.5, y: 0.5},
                            collage_type: p.collage_type ? self.convertCollageTypeToNewFormat(p.collage_type) : 0,
                            content_type: p.content_type ? p.content_type : 0,
                            content: p.content ? p.content : null,
                            content_full: p.content_full ? p.content_full : null,
                            frame: p.frame ? p.frame : 0,
                            start_time: p.start_time ? p.start_time : 0,
                            cutout_animation_type: p.cutout_animation_type ? p.cutout_animation_type : 0,
                            cutout_animation_duration: p.cutout_animation_duration ? p.cutout_animation_duration : 0,
                            cutout_start_time: p.cutout_start_time ? p.cutout_start_time : 0,
                            cutout_scale: p.cutout_scale ? p.cutout_scale : 0,
                            cutout_x: p.cutout_x ? p.cutout_x : 0.5,
                            cutout_y: p.cutout_y ? p.cutout_y : 0.5,
                            cutout_only: p.cutout_only ? p.cutout_only : 0,
                        });
                    })

                    if (self.client_parts.length) {
                        self.setVisiblePartCount(self.client_parts.length);
                    }

                    if (self.template.release_date) {
                        self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                        self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                    } else {
                        self.template.release_time = '12:00';
                    }

                    if (self.template.realVideoDuration) {
                        self.realVideoDuration = self.template.realVideoDuration;
                    }

                    if (self.template.realAudioDuration) {
                        self.realAudioDuration = self.template.realAudioDuration;
                    }

                    if (self.template.song_insta) {
                        self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                    }

                    if (self.template.song_tiktok) {
                        self.template.song_tiktok = 'https://vm.tiktok.com/' + self.template.song_tiktok;
                    }

                    if (self.template.effects) {
                        self.effect = self.template.effects.split(':')[0];
                        self.effect_intensity = self.template.effects.split(':')[1];
                    } else {
                        self.effect = ""
                        self.effect_intensity = 100
                    }

                    if (self.template.filters) {
                        self.filter = self.template.filters.split(':')[0];
                        self.filter_intensity = self.template.filters.split(':')[1];
                    } else {
                        self.filter = ""
                        self.filter_intensity = 100
                    }

                    let ratio = parseInt(self.template.ratio);
                    if (ratio > 1) {
                        self.heightCanvas = ratio === 2 ? 202.5 : ratio === 3 ? 72 : 640;
                    }

                    if (self.template.objects.length < 1) {
                        self.template.objects = [];
                        self.object_positions = [];
                    } else {

                        if (self.template.texts.length < 1) {
                            self.is_text_active = true;
                            self.active_text = 0;
                            self.active_type = 'object';
                        }

                        self.object_positions = [];

                        for (let i = 0; i < self.template.objects.length; i++) {

                            self.object_positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                            if (self.template.objects[i].id.indexOf('.svg') > -1) {

                                let dataSource = await axios.get(
                                    `${self.$hostname}/admin/services/graphics/svg/source`,
                                    {
                                        'params': {
                                            url: self.graphicsUrl + self.template.objects[i].id,
                                        },
                                        'headers': {
                                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                                        }
                                    })

                                    self.template.objects[i].source = dataSource.data


                            } else {
                                if (self.isGifSrc(self.template.objects[i].id) || !self.template.objects[i].dimensions) {
                                    try {
                                        const size = await self.loadRasterGraphic(self.template.objects[i].id);
                                        if (size && !self.template.objects[i].dimensions) {
                                            self.$set(self.template.objects[i], 'dimensions', size);
                                        }
                                    } catch (e) {
                                        console.log(e);
                                    }
                                }
                                self.template.objects[i].source = "Image"
                            }

                            self.textWaiting = true;

                            self.template.objects[i].is_visible = 1;
                            self.$nextTick(() => {
                                self.applyObjectContainerPosition(i);

                                self.video = self.$refs.videoContainer;

                                self.video.addEventListener("playing", function () {
                                    self.is_playing = true;
                                });

                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });

                                self.video.addEventListener("pause", function () {
                                    self.is_playing = false;
                                });

                                self.textWaiting = false;
                            });

                        }

                        self.$nextTick(() => {
                            self.applyAllObjectContainerPositions();
                        });

                    }

                    if ((self.template.frames || []).length > 0) {
                        self.frame_positions = [];

                        for (let i = 0; i < self.template.frames.length; i++) {
                            self.frame_positions.push(JSON.parse(JSON.stringify(self.default_positions)));
                        }

                        if (self.template.texts.length < 1 && self.template.objects.length < 1) {
                            self.is_text_active = true;
                            self.active_frame = 0;
                            self.active_type = 'frame';
                        }

                        setTimeout(() => {
                            for (let i = 0; i < self.template.frames.length; i++) {
                                self.applyFrameContainerPosition(i);
                            }

                            self.video = self.$refs.videoContainer;
                            if (self.video && !self.video._overlayWatchersBound) {
                                self.video._overlayWatchersBound = true;
                                self.video.addEventListener("playing", function () {
                                    self.is_playing = true;
                                });
                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });
                                self.video.addEventListener("pause", function () {
                                    self.is_playing = false;
                                });
                            }
                        }, 1000);
                    }

                    if (self.template.texts.length > 0) {

                        self.is_text_active = true;
                        self.active_text = 0;
                        self.active_type = 'text';

                        for (let i = 0; i < self.template.texts.length; i++) {
                            self.positions.push(self.default_positions);

                            if (!self.template.texts[i].angle) {
                                self.template.texts[i].angle = 0;
                            }

                            self.textWaiting = true;

                            setTimeout(() => {

                                if (self.$refs.draggableContainer[i].clientHeight < 1) {
                                    console.log('2275');
                                    location.reload();
                                }
                                let centerX = self.template.texts[i].position_x * 360 - self.$refs.draggableContainer[i].clientWidth / 2;
                                let centerY = self.template.texts[i].position_y * self.heightCanvas - self.$refs.draggableContainer[i].clientHeight / 2;

                                self.$refs.draggableContainer[i].style.left = centerX + 'px';
                                self.$refs.draggableContainer[i].style.top = centerY + 'px';

                                self.video = self.$refs.videoContainer;

                                self.video.addEventListener("playing", function () {
                                    //console.log('play ' + self.video.currentTime);

                                    self.is_playing = true;
                                });

                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });

                                self.video.addEventListener("pause", function () {
                                    //console.log('pause ' + self.video.currentTime);

                                    self.is_playing = false;
                                });

                                self.textWaiting = false;

                            }, 1000);
                        }
                    }

                    self.tags = response.data.tags;
                    self.template.tags = self.template.tags ? JSON.parse(self.template.tags) : [];

                    self.refreshTags();
                    self.captureUnsavedSnapshot();

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        getResources: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/resources/`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.server_effects = response.data.effects;
                    self.server_graphics = response.data.graphics;
                    self.server_filters = response.data.filters;
                    self.server_fonts = response.data.fonts;
                    self.server_frames = response.data.frames;

                    if (!self.active_object_category && self.server_graphics.length) {
                        self.active_object_category = self.server_graphics[0].name;
                    }

                    self.appendFonts();
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        appendFonts: function () {

            let newStyle = document.createElement('style');
            for (let i = 0; i < this.server_fonts.length; i++) {
                let font = this.server_fonts[i];

                newStyle.appendChild(document.createTextNode(`
                    @font-face {
                      font-family: '${font.name}';
                      src: url('/static/fonts/${font.src}');
                    }
                    `));

                this.fonts.push({
                    params: `'${font.name}', sans-serif;`,
                    code: font.name,
                    name: font.name,
                })
            }

            document.head.appendChild(newStyle);

        },
        showSVGModal: function () {
            this.is_object_changing = false;
            this.show_svg_modal = true;
        },
        showFramesModal: function () {
            this.is_frame_changing = false;
            this.show_frames_modal = true;
        },
        closeSVGModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
            }
        },
        closeFramesModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_frames_modal = false;
                this.is_frame_changing = false;
            }
        },
        //'888'
        showCollageModal: function (index) {
            this.active_part_index = index;

            let part = this.client_parts[index];
            if (part.collage_type === 'custom') {
                this.active_collage_category = 'Custom';
                if (part.frame && part.frame.rawData) {
                    this.custom_collage_rawData = JSON.parse(JSON.stringify(part.frame.rawData));
                } else {
                    this.custom_collage_rawData = JSON.parse(JSON.stringify(this.default_custom_collage_rawData));
                }
            } else {
                if (part.collage_type && part.collage_type !== 0) {
                    this.active_collage_category = part.collage_type.toString().split(';')[0].split('_')[0];
                }
                this.custom_collage_rawData = JSON.parse(JSON.stringify(this.default_custom_collage_rawData));
            }

            this.show_collage_modal = true;
        },
        closeCollageModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_collage_modal = false;
            }
        },
        save: function () {
            let self = this;

            this.commitVideoCount();
            this.calculateFrames();

            let template = JSON.parse(JSON.stringify(this.template));
            template.parts = self.partsForSave();

            if (!this.validatePartDurations()) {
                return false;
            }

            if ((template.type < 0) && Math.abs(this.sumParts - this.template.duration) > 0) {

                const notification = {
                    template: `<span><b>Длительность фрагментов не совпадает с указанной длительностью видео</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    })

                return false;
            }

            // if (Math.abs(this.realAudioDuration.toFixed(2) - this.realVideoDuration.toFixed(2)) > 0) {
            //
            //     const notification = {
            //         template: `<span><b>Длительность загруженного видео не совпадает с длительностью загруженного аудио</b></span>`
            //     };
            //
            //     self.$notifications.notify(
            //         {
            //             component: notification,
            //             icon: 'nc-icon nc-simple-remove',
            //             horizontalAlign: 'right',
            //             verticalAlign: 'top',
            //             type: 'danger'
            //         })
            //
            //     return false;
            // }

            if ((template.type < 0) && Math.abs(this.sumParts - this.realVideoDuration.toFixed(2)) > 0) {

                const notification = {
                    template: `<span><b>Указанная длительность видео не совпадает с реальной длительностью, полученной из видео</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    })

                return false;
            }

            if (template.song_insta) {
                const regex = /(\d{14,22})/gi;
                let match = regex.exec(template.song_insta);

                let reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    const notification = {
                        template: `<span><b>Проверьте формат ссылки на Reels Audio</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }
            }

            if (template.song_tiktok) {
                let parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    const notification = {
                        template: `<span><b>Проверьте формат ссылки на TikTok Audio</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }

            }

            if (this.video) {
                this.showPreview();
            }

            self.waiting = true;

            setTimeout(() => {

                if (this.is_text_active) {

                    for (let i = 0; i < self.template.texts.length; i++) {

                        let activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            let centerX = this.$refs.draggableContainer[i].offsetLeft + this.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            let centerY = this.$refs.draggableContainer[i].offsetTop + this.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / this.heightCanvas).toFixed(4));
                        }


                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.position_x = parseFloat(activeText.position_x);
                        activeText.position_y = parseFloat(activeText.position_y);
                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.bg_alpha = parseFloat(activeText.bg_alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_distance = parseFloat(activeText.shadow_distance);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.is_animated = parseInt(activeText.is_animated);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = self.normalizeTimeEnd(activeText.time_end);

                        activeText.text_brush_data = activeText.is_text_brush ? activeText.text_brush_data : [];

                        template.texts[i] = activeText;

                    }


                    for (let i = 0; i < self.template.objects.length; i++) {

                        let activeObj = template.objects[i];

                        activeObj.position_x = parseFloat(activeObj.position_x);
                        activeObj.position_y = parseFloat(activeObj.position_y);

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.shadow_alpha = parseFloat(activeObj.shadow_alpha);
                        activeObj.shadow_distance = parseFloat(activeObj.shadow_distance);
                        activeObj.shadow_blur = parseInt(activeObj.shadow_blur);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.is_animated = parseInt(activeObj.is_animated);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = self.normalizeTimeEnd(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[i] = activeObj;

                    }

                    for (let i = 0; i < (template.frames || []).length; i++) {
                        let activeFrame = template.frames[i];

                        activeFrame.alpha = parseFloat(activeFrame.alpha);
                        activeFrame.angle = parseInt(activeFrame.angle);
                        activeFrame.z_index = parseInt(activeFrame.z_index);
                        activeFrame.time_start = parseFloat(activeFrame.time_start);
                        activeFrame.time_end = self.normalizeTimeEnd(activeFrame.time_end);

                        template.frames[i] = activeFrame;
                    }

                } else {
                    template.texts = [];
                    template.objects = [];
                    template.frames = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                if (this.effect) {
                    template.effects = this.effect + ":" + this.effect_intensity;
                } else {
                    template.effects = "";
                }
                if (this.filter) {
                    template.filters = this.filter + ":" + this.filter_intensity;
                } else {
                    template.filters = ""
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                axios.post(
                    `${this.$hostname}/admin/templates/${this.id}/update`,
                    template,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        const notification = {
                            template: `<span><b>Шаблон был успешно изменен</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.waiting = false;
                        self.captureUnsavedSnapshot();

//                    self.$router.push('/templates');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                        self.waiting = false;
                    });


            }, 200);


        },
        remove: function () {
            let self = this;

            if (confirm("Внимание! Подтверждение удаления шаблона: " + self.id)) {
                axios.post(
                    `${this.$hostname}/admin/templates/${this.id}/delete`,
                    this.template,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        const notification = {
                            template: `<span><b>Шаблон был успешно удален</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            });

                        self.allowUnsavedLeave = true;
                        self.$router.push('/templates');
                    })
                    .catch(function (error) {

                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                    });
            }

        },
        clickContentFileButton: function (index) {
            let ref = (_.get(this.$refs, `contentFileInput_${index}`));
            ref[0].click();
        },
        uploadFile: function (event, type, index) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {
                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                if (data.file_type !== 'content') {
                    self.template[data.file_type] = data.url;
                    self.template[data.file_type + '_full'] = data.url_full;
                    self.template[data.file_type + '_size'] = data.filesize;

                    if (data.file_type === 'src') {
                        self.realVideoDuration = data.duration ? data.duration : null;
                    }

                    if (data.file_type === 'audio') {
                        self.realAudioDuration = data.duration ? data.duration : null;
                    }
                    if (self.video) {
                        self.showPreview();
                    }
                } else {
                    self.client_parts[index].content = data.url
                    self.client_parts[index].content_full = data.url_full
                }

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
        dragMouseDown: function (event) {
            event.preventDefault()

            let path = event.composedPath ? event.composedPath() : event.path;
            let id = null;
            _.each(path, (p) => {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            })

            if (!id) {
                return;
            }

            this.preview_drag_start = { x: event.clientX, y: event.clientY };
            this.preview_drag_moved = false;

            if (id.indexOf('o') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX
                this.object_positions[this.draggable_index].clientY = event.clientY
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = '0.6'

                document.onmousemove = this.objectDrag
                document.onmouseup = this.closeDragObject
            } else if (id.indexOf('f') === 0) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'frame';

                if (!this.frame_positions[this.draggable_index]) {
                    this.$set(this.frame_positions, this.draggable_index, JSON.parse(JSON.stringify(this.default_positions)));
                }

                this.frame_positions[this.draggable_index].clientX = event.clientX
                this.frame_positions[this.draggable_index].clientY = event.clientY
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = '0.6'

                document.onmousemove = this.frameDrag
                document.onmouseup = this.closeDragFrame
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX
                this.positions[this.draggable_index].clientY = event.clientY
                this.$refs.draggableContainer[this.draggable_index].style.opacity = '0.6'

                document.onmousemove = this.textDrag
                document.onmouseup = this.closeDragText
            }
        },
        markPreviewDragIfMoved: function (event) {
            if (this.preview_drag_moved || !this.preview_drag_start) {
                return;
            }

            let dx = event.clientX - this.preview_drag_start.x;
            let dy = event.clientY - this.preview_drag_start.y;
            if (dx * dx + dy * dy > 0) {
                this.preview_drag_moved = true;
            }
        },
        selectPreviewIfClicked: function (type) {
            if (this.preview_drag_moved || this.draggable_index == null) {
                return;
            }

            let index = parseInt(this.draggable_index);
            if (type === 'text') {
                this.selectText(index);
            } else if (type === 'object') {
                this.selectObject(index);
            } else if (type === 'frame') {
                this.selectFrame(index);
            }
        },
        textDrag: function (event) {
            event.preventDefault()
            this.markPreviewDragIfMoved(event);

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY
            this.positions[this.draggable_index].clientX = event.clientX
            this.positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer[this.draggable_index].style.top =
                (this.$refs.draggableContainer[this.draggable_index].offsetTop
                    - this.positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer[this.draggable_index].style.left =
                (this.$refs.draggableContainer[this.draggable_index].offsetLeft
                    - this.positions[this.draggable_index].movementX) + 'px'

            let centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            let centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / this.heightCanvas).toFixed(4));
        },
        closeDragText() {
            document.onmouseup = null
            document.onmousemove = null

            if (this.draggable_index != null && this.$refs.draggableContainer[this.draggable_index]) {
                this.$refs.draggableContainer[this.draggable_index].style.opacity = ''
            }

            this.selectPreviewIfClicked('text');
            this.draggable_index = null

            return false;
        },
        objectDrag: function (event) {
            event.preventDefault()
            this.markPreviewDragIfMoved(event);

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY
            this.object_positions[this.draggable_index].clientX = event.clientX
            this.object_positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer2[this.draggable_index].style.top =
                (this.$refs.draggableContainer2[this.draggable_index].offsetTop
                    - this.object_positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer2[this.draggable_index].style.left =
                (this.$refs.draggableContainer2[this.draggable_index].offsetLeft
                    - this.object_positions[this.draggable_index].movementX) + 'px'

            this.syncObjectModelFromElement(this.draggable_index);
        },
        closeDragObject() {
            document.onmouseup = null
            document.onmousemove = null

            if (this.draggable_index != null && this.$refs.draggableContainer2[this.draggable_index]) {
                this.$refs.draggableContainer2[this.draggable_index].style.opacity = ''
            }

            this.selectPreviewIfClicked('object');
            this.draggable_index = null

            return false;
        },
        frameDrag: function (event) {
            event.preventDefault()
            this.markPreviewDragIfMoved(event);

            this.frame_positions[this.draggable_index].movementX = this.frame_positions[this.draggable_index].clientX - event.clientX
            this.frame_positions[this.draggable_index].movementY = this.frame_positions[this.draggable_index].clientY - event.clientY
            this.frame_positions[this.draggable_index].clientX = event.clientX
            this.frame_positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer3[this.draggable_index].style.top =
                (this.$refs.draggableContainer3[this.draggable_index].offsetTop
                    - this.frame_positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer3[this.draggable_index].style.left =
                (this.$refs.draggableContainer3[this.draggable_index].offsetLeft
                    - this.frame_positions[this.draggable_index].movementX) + 'px'

            this.updateFramePositionFromDom(this.draggable_index);
        },
        closeDragFrame() {
            document.onmouseup = null
            document.onmousemove = null

            if (this.draggable_index != null && this.$refs.draggableContainer3[this.draggable_index]) {
                this.$refs.draggableContainer3[this.draggable_index].style.opacity = ''
            }

            this.selectPreviewIfClicked('frame');
            this.draggable_index = null

            return false;
        },
        renderCollagePart(collageType, partIndex) {
            if (!collageType) {
                return;
            }

            if (collageType === 'custom') {
                let frame = this.client_parts[partIndex] && this.client_parts[partIndex].frame;
                return this.renderCustomCollageFrame(frame, 0.7);
            }

            let layout = collageType.split(';');
            let category = layout[0].split('_')[0];
            let collageId = layout[0];
            let partId = parseInt(layout[1]);
            let collages = _.find(this.collages, (c) => c.name === category)
            let collage = _.find(collages.data, (c) => c.id === collageId)

            return this.renderCollage(collage, 0.7, partId - 1);
        },
        renderCustomCollageFrame(frame, scale = 1) {
            if (!frame) {
                return '';
            }

            let left = parseFloat(frame.x) * 108 * scale;
            let top = parseFloat(frame.y) * 192 * scale;
            let width = parseFloat(frame.w) * 108 * scale;
            let height = parseFloat(frame.h) * 192 * scale;
            let rtl = (parseFloat(frame.b_tl) || 0) * width;
            let rtr = (parseFloat(frame.b_tr) || 0) * width;
            let rbr = (parseFloat(frame.b_br) || 0) * width;
            let rbl = (parseFloat(frame.b_bl) || 0) * width;

            let containerStyle =
                "position:relative;" +
                `width:${108 * scale}px;height:${192 * scale}px;` +
                "background:#f7f7f7;overflow:hidden;" +
                "border: 1px solid #000;" +
                "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            let frameStyle =
                "position:absolute;" +
                `left:${left}px;top:${top}px;` +
                `width:${width}px;height:${height}px;` +
                "background:#BAE1FF;" +
                `border-radius:${rtl}px ${rtr}px ${rbr}px ${rbl}px;overflow:hidden;` +
                "display:flex;align-items:center;justify-content:center;" +
                "color:rgba(0,0,0,.5);" +
                "font:600 12px sans-serif;";

            return `<div style="${containerStyle}"><div class="collage-item-part diagonal-lines" style="${frameStyle}">1</div></div>`;
        },
        renderCollage(layout, scale = 1, partId = null) {

            let palette = [
                "#FFDFBA","#FFFFBA","#BAFFC9","#BAE1FF",
                "#D7C4F3","#C1F0F6","#FAD6A5","#F7C5CC","#C9E4DE"
            ];

            let containerStyle =
                "position:relative;" +
                `width:${108 * scale}px;height:${192 * scale}px;` +
                "background:#f7f7f7;overflow:hidden;" +
                `border: 1px solid ${partId === null && this.previous_collage_id === layout.id ? 'red' : '#000'};` +
                "box-shadow:0 6px 20px rgba(0,0,0,.08);";

            let html = '<div style="' + containerStyle + '">';

            for (let i = 0; i < layout.frames.length; i++) {
                let f = layout.frames[i];

                let left = f.x * 108 * scale;
                let top = f.y * 192 * scale;
                let width = f.width * 108 * scale;
                let height = f.height * 192 * scale;

                let color = palette[i % palette.length];

                let radiusStyle = "0px";
                if (f.crop && f.crop.type === "roundedCorner") {
                    let v = f.crop.value;
                    if (v < 0) v = 0;
                    if (v > 1) v = 1;
                    radiusStyle = (v * Math.min(width, height) / 2) + "px";
                }

                let frameStyle =
                    "position:absolute;" +
                    "left:" + left + "px;top:" + top + "px;" +
                    "width:" + width + "px;height:" + height + "px;" +
                    "background:" + color + ";" +
                    "border-radius:" + radiusStyle + ";overflow:hidden;" +
                    "display:flex;align-items:center;justify-content:center;" +
                    "color:rgba(0,0,0,.5);" +
                    "font:600 12px sans-serif;";

                let params = `${layout.id};${i + 1};${f.x};${f.y};${f.width};${f.height}`;

                html += `
                          <div
                            data-params="${params}"
                            class="collage-item-part ${partId === i ? 'diagonal-lines' : ''}"
                            style="${frameStyle}"
                          >
                            ${i + 1}
                          </div>
                        `;
            }

            html += "</div>";
            return html;
        },
    }
}

</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

.layers-sticky {
    position: sticky;
    top: 0;
    z-index: 20;
    background-color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
}

.preview-sticky {
    position: sticky;
    z-index: 10;
}

.range {
    cursor: pointer !important;
}

#preview-container {
    display: block;
    margin: 0 auto 30px auto;
    width: 360px;
}

.object-preview {
    width: 100px;
    display: block;
    cursor: pointer;
    margin-bottom: 15px;
}

#player {
    width: 360px;
    height: 640px;
    position: relative;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all .3s ease-out;
}
#player video {
    width: 360px;
    position: relative;
    z-index: 0;
}

video::-webkit-media-controls-fullscreen-button {
    display: none !important;
}

.btn-toggle {
    width: 360px;
    height: 40px;
    margin: 33px auto;
    background: #000;
    border: none;
    font-size: 15px;
    opacity: 1;
    color: #fff;
}

.btn-toggle:hover {
    opacity: 0.8 !important;
}

.btn-toggle.active-state {
    display: block;
}

.draggable-header {
    white-space: pre;
    cursor: pointer;
}

.draggable-header.active {
    outline: 1px solid #FFD700;
    outline-offset: 4px;
}

.draggable-header.nospace {
    white-space: normal;
    padding: 0;
}

.draggable-container {
    top: 0px;
    position: absolute;
}
#player svg,
#preview svg {
    display: block;
}

.text-area {
    width: 100%;
    padding: 8px 12px;
}

.btn-save {
    width: 150px;
}

.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.btn-text, .btn-text:active, .btn-text:hover {
    color: #000;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-text.active {
    color: #000;
    background-color: #D5C9E9;
    border: 1px solid #D5C9E9;
}

.btn-text:hover {
    opacity: 0.6;
}

.btn-text.control-btn {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
}

.button-preview {
    height: 20px;
    width: 70px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.button-preview:active {

}

.control-btn:last-child {
    margin-left: 0px;
}

.btn-remove, .btn-remove:active {
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    margin-top: 20px
}

.btn-delete-collage, .btn-delete-collage:active, .btn-delete-collage:hover, .btn-delete-collage:focus  {
    opacity: 0.5;
    font-size: 12px;
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    position: absolute;
    bottom: 5px;
    right: 20px;
}
.btn-delete-collage:hover {
    opacity: 0.3;
}

.checkbox-block {
    margin-top: 20px;
    margin-left: 20px;
}


.color-set span {
    width: 37px;
    height: 26px;
    display: inline-block;
    margin-left: 5px;
    border-radius: 5px;
    cursor: pointer;
}

.color-set span:first-child {
    border: 1px solid #E3E3E3;
}

.color-set span.active {
    border: 1px solid #000000;
}
.tags-set {
    margin-top: 8px;
}
.tags-set div {
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 5px;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: 1px solid #E3E3E3;
    font-size: 14px;
}
.tags-set div:hover {

}
.tags-set div.active {
    border: 1px solid transparent;
    background-color: #54abfe47;
}

.btn-file {
    display: none;
}

.upload-button {
    margin-top: 10px;
}

.inline-link {
    font-size: 16px;
    margin-left: 5px;
}

.inline-link span, h4 .bg-danger {
    padding: 3px;
    border-radius: 4px;
}

.bg-danger {
    font-size: 16px;
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
    cursor: pointer;
}

.label-checkbox {
    margin-right: 10px;
    cursor: pointer;
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.mb10 {
    margin-bottom: 10px
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.param-span, .param-span label {
    font-size: 0.8rem;
    color: #000;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 1.7s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 1.7s ease;
}


.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-header button {
    text-transform: capitalize;
}

.modal-body {
    margin: 20px 0;
    overflow: scroll;
    height: 500px;
}

.object-item, .frame-item {
    display: inline-block;
    max-width: 100px;
    height: 64px;
    margin-right: 20px;
    cursor: pointer;
    margin-bottom: 10px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}
.collage-item {
    width: 108px;
    height: 192px;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}
.collage-btn {
    margin-top: 25px;
    font-size: 12px;
}
.collage-category {
    padding-left: 40px;
    padding-right: 40px;
}

.object-item:first-child {
    margin-left: 0;
}

.object-item:hover {
    opacity: 0.6;
}

.object-item img {
    width: 100%;
    max-height: 64px;
    display: block;
}

.modal-header {
    padding-left: 0;
    display: block;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.texts-buttons button {
    position: relative;
}
.widget-icon {
    width: 120px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.frame-item {
    max-width: 100%;
    height: 200px;
}
.frame-item img {
    width: 100%;
    height: 100%;
    display: block;
}
.texts-buttons {
    margin-bottom: 25px;
}

.animated-icon {
    font-size: 30px;
    position: absolute;
    color: #6dc030;
    top: -15px;
    right: 0;
}

.effect-values, .cutout-preview {
    display: block;
    width: 100%;
    font-size: 10px;
    text-transform: uppercase;
    margin-left: 15px;
    color: #9A9A9A;
}

.effect-values {
    margin-top: 15px;
}
.effect-preview, .cutout-preview {
    width: 50px;
    height: 89px;
    margin-left: 9px;
    display: block;
    border: 1px solid #E3E3E3;
    cursor: pointer;
    position: relative;
}

.effect-area, .cutout-area {
    width: 30px;
    height: 30px;
    border: 1px solid #FFD700;
    border-radius: 50%;
    display: block;
    position: relative;
    top: 10px;
    left: 10px
}

.effect-center, .cutout-center {
    display: block;
    width: 8px;
    height: 8px;
    background: #FFD700;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 10px;
}
.collage-preview {
    cursor: pointer;
}
.collage-custom-form {
    padding: 10px 0;
}
.collage-custom-form .btn {
    margin-top: 10px;
}
.cutout-area {
    border: 1px solid #2140f5;
}
.cutout-center {
    background: #2140f5;
}
.cutout-position {
    font-size: 13px;
}

.bordered:last-child {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 15px;
    margin-bottom: 15px;
}

.row {
    margin-right: -13px;
}

.ml9 {
    margin-left: 9px !important;
    margin-bottom: 15px;
}

.block-number {
    display: block;
    margin-top: 0;
    font-size: 38px;
    font-weight: 700;
    color: #000;
}
.part-actions {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
    margin-bottom: 6px;
}
.part-action-btn {
    padding: 2px 8px;
    font-size: 11px;
    line-height: 1.4;
    border-radius: 3px;
    border: 1px solid #ccc;
    background: #fff;
    color: #333;
    cursor: pointer;
}
.part-action-btn:hover {
    background: #f3f3f3;
}
.part-action-delete {
    color: #d9534f;
    border-color: #e7b2ae;
}
.part-action-delete:hover {
    background: #fff5f4;
}
.paste-durations {
    margin-bottom: 16px;
}
.paste-durations textarea.form-control {
    min-height: 90px;
    height: auto;
    resize: vertical;
    line-height: 1.4;
}
.paste-durations textarea.form-control::placeholder {
    white-space: pre-line;
}
.paste-durations-hint {
    font-size: 12px;
    color: #888;
    margin: 4px 0 8px;
}
.paste-durations-applied {
    display: block;
    margin-top: 2px;
    color: #1b8a3a;
}
.paste-durations-btn {
    font-size: 12px;
    padding: 4px 12px;
    margin-bottom: 8px;
}
.part-empty-duration {
    outline: 2px solid #ff4632;
    outline-offset: 4px;
    border-radius: 4px;
    background-color: rgba(255, 70, 50, 0.06);
}
.part-duration-error .form-control,
.part-duration-error .form-control:focus {
    border-color: #ff4632 !important;
    background-color: #fff5f4;
}
.realDuration, .partsDuration {
    font-size: 14px;
}
.realDuration span, .partsDuration span {
    font-size: 18px;
}
.btn-delete {
    margin-right: 20px;
    opacity: 0.1;
}

</style>

<style>

.collage-custom-form label,
.collage-custom-form .control-label {
    font-size: 10px !important;
    font-weight: normal !important;
    color: #9A9A9A !important;
    margin-bottom: 5px !important;
    text-transform: uppercase !important;
}

.collage-modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
}

.collage-frame-footer {
    flex: 1;
    text-align: center;
    font-size: 15px;
    color: #000;
    word-break: break-all;
    line-height: 1.35;
    margin-right: 20px;
}

.modal-body .collage-item-part:hover {
    opacity: 0.6 !important;
}
.modal-body .collage-item-part:hover {
    position: relative;
    z-index: 0; /* важно, чтобы псевдоэлемент был поверх */
}
.modal-body .collage-item-part:hover::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none; /* чтобы клики проходили сквозь */
    border-radius: inherit;

    background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 8px,
        rgba(0, 0, 0, 0.8) 9px,
        rgba(0, 0, 0, 0.8) 10px
    );
}

.diagonal-lines {
    position: relative;
    z-index: 0; /* важно, чтобы псевдоэлемент был поверх */
}

.diagonal-lines::after {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none; /* чтобы клики проходили сквозь */
    border-radius: inherit;

    background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 8px,
        rgba(0, 0, 0, 0.8) 9px,
        rgba(0, 0, 0, 0.8) 10px
    );
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Template/Edit.vue